// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-16T14:53:21.079Z
// Property: Cowles Landing (ID: 6767906449167016)
// Collections: 17 amenities, 3 floorplans (live), 48 photos, 74 POIs, 2 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449167016",
  "property_external_id": "1145CWLD",
  "property_zillow_url": "https://www.zillow.com/apartments/san-diego-ca/cowles-landing/CnXMgb/",
  "property_apartments_url": "https://www.apartments.com/san-carlos-village-san-diego-ca/3s05rpf/",
  "property_google_business_url": "https://www.google.com/maps/place/Cowles+Landing+Apartments/data=!4m2!3m1!1s0x0:0xca0460cbb24807a7?sa=X&ved=2ahUKEwih8abrq7ySAxUwN94AHazkFZEQ_BJ6BAg6EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "49961473679",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "1145CWLD",
  "property_status": null,
  "property_slug": "cowles-landing",
  "property_name": "Cowles Landing",
  "property_website_url": "https://www.cowleslandingapts.com/",
  "property_domain": "https://www.cowleslandingapts.com/",
  "property_address": "7717 Tommy St",
  "property_full_address": "7717 Tommy St, San Diego, CA 92119",
  "property_address_1": "7717 Tommy St",
  "property_address_2": null,
  "property_address_city": "San Diego",
  "property_address_state": "CA",
  "property_address_zip_full": "92119",
  "property_address_zip": "92119",
  "property_address_country": "US",
  "property_address_county": "San Diego County",
  "property_neighborhood_address": "San Carlos",
  "property_address_latitude": "32.8058815",
  "property_address_longitude": "-117.0263934",
  "property_email": "cowleslanding@liveamc.com",
  "property_phone": "(619) 461-4111",
  "property_call_tracking_phone": "888-624-2187",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Nestled in sunny San Diego, Cowles Landing offers a serene escape for residents 55 and better. Enjoy evenings illuminated by enchanting lights, relax by the community pool or spa, and experience modern living with convenient amenities like reserved parking and air conditioning. Your ideal studio awaits—connect with us today!",
  "property_long_description": "Welcome to Cowles Landing, your serene oasis in the heart of San Diego, CA, designed exclusively for residents aged 55 and over. Our thoughtfully appointed studio apartment floor plans offer a perfect blend of comfort and convenience, ensuring you feel right at home from day one. Enjoy delightful evening views illuminated by our evening lights, creating a warm ambiance that invites relaxation.\n\nAt Cowles Landing, we prioritize your lifestyle with a host of premium amenities tailored to meet your needs. Experience the refreshing community pool and spa, perfect for unwinding after a busy day. With reserved parking and easy freeway access, coming and going is a breeze. Our non-smoking property promotes a healthy living environment, while the on-site gardener enhances the beauty of our community.\n\nEach apartment is outfitted with essential modern conveniences, including air conditioning, a refrigerator, dishwasher, garbage disposal, oven, and stove, along with easy-care vinyl plank flooring and vertical blinds for added privacy. Enjoy the perks of included water and trash services, alongside the ease of community laundry facilities.\n\nWhether it's relaxing on your private patio or gathering with neighbors in our welcoming clubhouse, Cowles Landing is designed to foster community while providing you with the comfort and tranquility you deserve. \n\nFind your new home today—browse our availability or schedule a tour to visit our charming community and experience the Cowles Landing lifestyle firsthand!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-b82e-74c2-8f51-eea07059347a.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
    "public_id": "019d02d4-b82e-74c2-8f51-eea07059347a",
    "storage_key": "property/6767906449167016/019d02d4-b82e-74c2-8f51-eea07059347a.webp",
    "width": 1920,
    "height": 1200
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "160",
  "property_year_built": "1980",
  "property_year_renovated": null,
  "property_walk_score": "12",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "100",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "Breed restrictions apply.",
  "property_pet_policy_description": "Dogs allowed (breed restrictions apply): up to 75 lb, maximum 2 dogs. Cats allowed, maximum 2 cats. Monthly pet rent: $50 per pet.",
  "property_petpolicy_info": "Dogs allowed (breed restrictions apply): up to 75 lb, maximum 2 dogs. Cats allowed, maximum 2 cats. Monthly pet rent: $50 per pet.",
  "property_online_leasing_url": "https://myrentalapplication.com/index/amccowleslanding",
  "property_resident_portal_url": "https://portal.goprisma.com/common/login?returnUrl=%2Fauth%2Flogin%3FreturnUrl%3D%252Fdashboard",
  "property_apply_now_url": "https://myrentalapplication.com/index/amccowleslanding",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-c9c4-745e-899b-e2bc47b227d3.webp",
  "property_primary_logo_media": {
    "alt_text": "Cowles Landing Apartments logo",
    "public_id": "019d02d6-c9c4-745e-899b-e2bc47b227d3",
    "storage_key": "property/6767906449167016/019d02d6-c9c4-745e-899b-e2bc47b227d3.webp",
    "width": 640,
    "height": 246
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-d632-741c-86ba-2beeb2a3614b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cowles Landing Apartments logo with mountains and sun icon.",
    "public_id": "019d02d6-d632-741c-86ba-2beeb2a3614b",
    "storage_key": "property/6767906449167016/019d02d6-d632-741c-86ba-2beeb2a3614b.webp",
    "width": 640,
    "height": 247
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-e07a-76d8-a913-59a5fd48da24.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cowles Landing Apartments logo.",
    "public_id": "019d02d6-e07a-76d8-a913-59a5fd48da24",
    "storage_key": "property/6767906449167016/019d02d6-e07a-76d8-a913-59a5fd48da24.webp",
    "width": 640,
    "height": 247
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#5B5547",
  "property_secondary_color": "#86564D",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2 Beds",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2 Beds",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "463 - 906",
  "property_sqft_min": "463",
  "property_sqft_max": "906",
  "property_price_range": "$1450 - $1895",
  "property_price_min": "1450",
  "property_price_max": "1895",
  "property_available_units": null,
  "property_facebook_url": "https://www.facebook.com/CowlesLandingApartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJD0L5wLVX2YARpwdIsstgBMo",
  "property_youtube_url": "https://www.youtube.com/watch?v=jb3Q6Z_ywy4",
  "property_yelp_url": "https://www.yelp.com/biz/san-carlos-village-apartments-san-diego",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cowles Landing",
  "property_home_romance_title": "Find Your Heart at Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Cowles Landing in sunny San Diego, CA! Choose from stylish studio, one, or two-bedroom apartments featuring modern comforts like air conditioning, dishwashers, and luxurious vinyl plank flooring. Dive into relaxation at our community pool and spa, and enjoy the enchanting evening lights that illuminate your home.",
  "property_home_floorplans_blurb": "Welcome to Cowles Landing, where modern living meets serene San Diego vibes. Choose from our thoughtfully designed studio apartments, tailored to fit your unique style. Each home offers a perfect blend of comfort and sophistication. Browse our available apartment homes today and embrace your new lifestyle among coastal charm.",
  "property_home_gallery_blurb": "At Cowles Landing in beautiful San Diego, choose from an array of thoughtfully designed floor plans, from cozy studios to spacious two-bedrooms. Enjoy the twinkling evening lights, relax by the community pool, or unwind in your private balcony oasis. Picture yourself living here—where comfort meets convenience!",
  "property_home_neighborhood_blurb": "Nestled in the heart of San Diego, Cowles Landing offers a unique blend of modern living and vibrant local culture. Immerse yourself in nature at Mission Trails Regional Park, enjoy the arts at the Spanish Village Art Center, or catch a game at Viejas Arena. Explore diverse floor plans and vibrant surroundings that elevate your lifestyle.",
  "property_home_reviews_blurb": "At Cowles Landing in vibrant San Diego, residents rave about the “friendly community and stunning amenities.\" Experience the perfect blend of comfort and style in your new home. Curious about life here? Check out what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of San Diego, Cowles Landing offers more than just stylish studio, one, and two-bedroom apartments. Enjoy access to vibrant local culture with nearby attractions like Mission Trails Regional Park, San Diego Zoo, and Grossmont Center. Experience community living infused with adventure right outside your door!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cowles Landing in sunny San Diego, enjoy a lifestyle enriched by modern studio, one-bedroom, and two-bedroom homes. Indulge in resort-style amenities like a shimmering community pool, relaxing spa, and evening lights. With reserved parking and inclusive features, comfort and convenience await your arrival. Explore our amazing community amenities today!",
  "property_applynow_blurb": "Welcome to Cowles Landing in sunny San Diego, where comfort meets convenience. Choose from spacious studio, one, and two-bedroom floor plans, complete with modern amenities like a sparkling pool, reserved parking, and private balconies. Experience a smoke-free lifestyle with inclusive utilities—apply online today to secure your new home!",
  "property_contactus_blurb": "At Cowles Landing in sunny San Diego, find the perfect living space tailored to your needs. Choose from stylish studio, one-bedroom, and two-bedroom floor plans designed for comfort and convenience. Our leasing team is ready to answer any questions you have—reach out today for more information!",
  "property_faqs_blurb": "Nestled in the heart of San Diego, Cowles Landing offers a variety of thoughtfully designed floor plans, including cozy studios and spacious two-bedroom units. Have questions? Our FAQs page provides essential insights into community living. Uncover everything you need to know for your next home sweet home.",
  "property_floorplans_blurb": "At Cowles Landing in vibrant San Diego, our thoughtfully designed floor plans cater to every lifestyle, from stylish studios to spacious two-bedroom apartments. Embrace the coastal charm and modern amenities as you envision your ideal home. Browse our available apartment homes today and uncover your perfect floor plan!",
  "property_gallery_blurb": "At Cowles Landing in sunny San Diego, vibrant evenings shimmer under the soft glow of community lights. Picture yourself lounging by the pool, enjoying modern amenities in stylish studios, one, and two-bedroom layouts. Revel in carefree living with all utilities included, plus the beauty of your own balcony.",
  "property_interactivemap_blurb": "Welcome to Cowles Landing in sunny San Diego, CA, where modern living meets serene community vibes. Choose from our stylish studio, one-bedroom, or two-bedroom floor plans. Enjoy sought-after amenities like a sparkling pool, relaxing spa, and reserved parking. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "<p>Welcome to Cowles Landing, where coastal charm meets modern living in sunny San Diego, CA. Enjoy beautifully crafted apartments surrounded by lush greenery and vibrant community spaces. With pet-friendly amenities and a prime location, your ideal home awaits at Cowles Landing—where comfort and community come together seamlessly.</p><p><br></p>",
  "property_referafriend_blurb": "At Cowles Landing in sunny San Diego, our diverse floor plans—including cozy studios, spacious one-bedrooms, and inviting two-bedrooms—cater to your unique lifestyle. Share the joy of living here with friends, because great friends make great neighbors. Refer a friend today and build your perfect community!",
  "property_residentaccess_blurb": "<p>At Cowles Landing in sunny San Diego, we offer thoughtfully designed studio, one-bedroom, and two-bedroom floor plans tailored to your lifestyle. Access your resident portal seamlessly to pay rent and schedule maintenance. Enjoy the ease of living at Cowles Landing!</p>",
  "property_reviews_blurb": "At Cowles Landing in San Diego, residents rave about their community experience, with one expressing, “The friendly atmosphere makes every day feel special.” Dive into our reviews to hear more about the vibrant lifestyle, exceptional amenities, and welcoming neighbors that make living here truly enjoyable!",
  "property_created_at": "1769625035878",
  "property_scheduletour_blurb": "At Cowles Landing in sunny San Diego, we offer a variety of stylish floor plans, including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments. Each home is designed for comfort and lifestyle. Schedule a tour today and see why our residents love calling Cowles Landing home!",
  "property_thankyou_blurb": "Thank you for reaching out to Cowles Landing in sunny San Diego! We'll connect soon to discuss our stylish studio, one-bedroom, and two-bedroom floor plans tailored for your lifestyle. Get ready to elevate your living experience in a vibrant community that feels like home. Stay tuned!",
  "property_virtualtours_blurb": "At Cowles Landing in sunny San Diego, CA, your perfect home awaits! From stylish studios to spacious two-bedroom plans, each layout is designed for comfort and convenience. Ready to envision your new lifestyle? Take a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2026 All Rights Reserved. Cowles Landing",
  "property_seo_title_home": "Cowles Landing |  Apartments in San Diego, CA",
  "property_seo_description_home": "Discover Cowles Landing in San Diego! Enjoy stylish studios and spacious two-bedrooms, plus resort-style amenities for your comfort.",
  "property_seo_title_floorplans": "Floor Plans | San Diego, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your sanctuary in San Diego at Cowles Landing. Browse unique studio, one, and two-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | San Diego, CA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Cowles Landing in San Diego! Enjoy our stunning amenities like a pool, spa, and modern apartments designed for comfort. Join us!",
  "property_seo_title_gallery": "Gallery | Apartments in San Diego, CA",
  "property_seo_description_gallery": "Immerse yourself in Cowles Landing's stunning San Diego living! From refreshing pools to cozy balconies, see your future home in our photo gallery!",
  "property_seo_title_virtualtours": "Virtual Tours | Cowles Landing Apartments",
  "property_seo_description_virtualtours": "Experience Cowles Landing in San Diego! Take a virtual tour of our stylish studio, one, and two-bedroom apartments. Your ideal home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Cowles Landing Apartments",
  "property_seo_description_interactivemap": "Find your perfect oasis at Cowles Landing, San Diego! Check out our interactive map for floor plans, amenities, and make your dream apartment a reality!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Diego, CA",
  "property_seo_description_neighborhood": "Experience the vibrant San Diego lifestyle at Cowles Landing! Uncover local favorites and hidden gems just steps from your new home. Join us today!",
  "property_seo_title_contact": "Contact Us | Cowles Landing",
  "property_seo_description_contact": "Connect with Cowles Landing in sunny San Diego! Choose from studio to two-bedroom floor plans and let our leasing team assist your new adventure.",
  "property_seo_title_faqs": "FAQs | Apartments in San Diego, CA",
  "property_seo_description_faqs": "Discover your ideal home at Cowles Landing in sunny San Diego! Enjoy modern amenities, stunning views, and a welcoming community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Diego, CA",
  "property_seo_description_reviews": "Uncover the charm of Cowles Landing in San Diego! Read resident reviews and find out why our studio, one-, and two-bedroom apartments feel like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in San Diego, CA",
  "property_seo_description_applynow": "Experience coastal living at Cowles Landing, San Diego! Choose from spacious studios to two-bedroom apartments with luxury amenities. Lease today!",
  "property_seo_title_residentaccess": "Resident Access | Cowles Landing",
  "property_seo_description_residentaccess": "Welcome to Cowles Landing! Log in to your resident portal for easy rent payment, maintenance requests, and seamless community living in sunny San Diego.",
  "property_seo_title_referafriend": "Refer A Friend | Cowles Landing",
  "property_seo_description_referafriend": "Great friends make great neighbors at Cowles Landing! Refer a friend today and share the joys of San Diego living in our vibrant apartment community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cowles Landing",
  "property_seo_description_scheduletour": "Experience coastal living at Cowles Landing in sunny San Diego! Schedule a tour today and envision your new life in our vibrant community.",
  "property_seo_title_privacy": "Privacy Policy | Cowles Landing",
  "property_seo_description_privacy": "At Cowles Landing in sunny San Diego, your privacy matters. Learn how we protect your information and enjoy our vibrant community. View our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Cowles Landing",
  "property_seo_description_accessibility": "At Cowles Landing in San Diego, we prioritize digital inclusion. Experience accessible living and community support tailored for everyone. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Cowles Landing",
  "property_seo_description_sitemap": "Navigate your way through Cowles Landing in sunny San Diego! Find everything you need with our comprehensive sitemap—your gateway to coastal living awaits!",
  "property_seo_title_thankyou": "Thank You | Cowles Landing",
  "property_seo_description_thankyou": "Thank you for reaching out to Cowles Landing in San Diego! Expect a warm welcome and expert guidance from our team to find your ideal home.",
  "property_seo_title_pets": "Pet Policy | Apartments in San Diego, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791473668114",
  "amenities": [
    {
      "id": "custom_11ef72a1-d2d2-4ac5-a0f1-f415cc76f9a8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Renovated Interiors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b1e6a4c-5f04-4b03-9a48-9fd11f0c29be",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d7feed95-6401-4b7f-a517-83ed0d1f719a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2cf3bf8-6f89-4f46-a6aa-00c4bf410e1e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9d272e0e-e69a-47f1-86df-7f7f88027da7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Custom Tile Backsplash",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc328147-26b1-4b96-b44d-6850ca0f197d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher and Garbage Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8471c318-b3fd-4a0b-8a90-81de12e643ab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Hard Surface Floors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc7eed13-fda0-4d96-9aee-c36090057df9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Quiet, Dual‑Pane Vinyl Windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d7f4f8b7-db36-47b7-baa4-ff856a87e372",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6f8e50a5-40fd-4eab-88be-f7f7bbd0c163",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balconies or Patios (select units)",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6fe4334c-5242-43fb-ae71-37972071bc5b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Keyless Entry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_06a303c6-b96b-4e05-bfe6-22ac8028e36f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Resort-Style Pool and Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb845cde-8a71-406e-9e4f-147730eaa6f0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ Entertainment Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f838484e-17f0-4ea8-a240-8c9f8358ef78",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6682a22a-243d-4175-bef6-271ca49fb14d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2bd05ba5-e431-45ca-ba3c-dfb51d827663",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Dog/Cat Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1653160e-21f2-428f-a99a-2caca9c2eb91",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_1b6724bc-3a34-492f-b4ff-a97419b01a7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-1d1b-72da-9e53-c0aaaae35e06.webp",
      "image_media": {
        "alt_text": "A communal living area with sofas, tables, chairs, a fireplace, and a Christmas tree.",
        "public_id": "019d02d5-1d1b-72da-9e53-c0aaaae35e06",
        "storage_key": "property/6767906449167016/019d02d5-1d1b-72da-9e53-c0aaaae35e06.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy this comfortable communal living area, perfect for gathering with friends and neighbors. Features include plush seating, dining tables, a cozy fireplace, and festive holiday decorations.",
      "link": "",
      "alt_text": "A communal living area with sofas, tables, chairs, a fireplace, and a Christmas tree.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e85e86f7-4f74-4c6f-9d5b-6c615a795251",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-0fbc-72aa-8849-5400304d566c.webp",
      "image_media": {
        "alt_text": "Community lounge area with sofas, coffee table, TV, and bookshelves.",
        "public_id": "019d02d5-0fbc-72aa-8849-5400304d566c",
        "storage_key": "property/6767906449167016/019d02d5-0fbc-72aa-8849-5400304d566c.webp",
        "width": 1800,
        "height": 1201
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting community lounge, featuring comfortable seating, entertainment options, and a cozy atmosphere.",
      "link": "",
      "alt_text": "Community lounge area with sofas, coffee table, TV, and bookshelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29c5da66-8bfb-438b-89de-689fc52e3720",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-fefc-70cd-add4-c880700e18b3.webp",
      "image_media": {
        "alt_text": "Outdoor grills and a pool area in a community courtyard.",
        "public_id": "019d02d4-fefc-70cd-add4-c880700e18b3",
        "storage_key": "property/6767906449167016/019d02d4-fefc-70cd-add4-c880700e18b3.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy community grilling areas equipped with multiple grills, perfect for outdoor gatherings. Relax by the pool after a cookout.",
      "link": "",
      "alt_text": "Outdoor grills and a pool area in a community courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a8c6d37b-d522-46bc-9d27-bc797625a0dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-fda0-775d-9384-a0e8290a0a37.webp",
      "image_media": {
        "alt_text": "Outdoor picnic table with umbrella and grill area in a community courtyard.",
        "public_id": "019d02d4-fda0-775d-9384-a0e8290a0a37",
        "storage_key": "property/6767906449167016/019d02d4-fda0-775d-9384-a0e8290a0a37.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings with the community picnic area, complete with a table, umbrella, and grill, surrounded by lush greenery.",
      "link": "",
      "alt_text": "Outdoor picnic table with umbrella and grill area in a community courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d5838e0e-32d5-4292-ad1a-66ca0977a7e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-f416-76ce-ad1d-ef78343cce9f.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a table and benches surrounded by lush greenery.",
        "public_id": "019d02d4-f416-76ce-ad1d-ef78343cce9f",
        "storage_key": "property/6767906449167016/019d02d4-f416-76ce-ad1d-ef78343cce9f.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy the outdoors with this charming seating area, perfect for relaxing or socializing amidst beautiful landscaping.",
      "link": "",
      "alt_text": "Outdoor seating area with a table and benches surrounded by lush greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_65b2225c-b593-4e81-8efa-f65f0144cbd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-f161-749d-821f-3581ee6cc60b.webp",
      "image_media": {
        "alt_text": "Bench with decorative pillows in front of apartment buildings with lush landscaping.",
        "public_id": "019d02d4-f161-749d-821f-3581ee6cc60b",
        "storage_key": "property/6767906449167016/019d02d4-f161-749d-821f-3581ee6cc60b.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy the beautiful grounds and serene atmosphere with comfortable seating and vibrant flora.",
      "link": "",
      "alt_text": "Bench with decorative pillows in front of apartment buildings with lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4219ae36-6b6f-445c-a71a-eec9e85a5f66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-e72f-7298-9a8f-12905cc4ca0d.webp",
      "image_media": {
        "alt_text": "Apartment building entrance with lush greenery and a bench with floral cushions.",
        "public_id": "019d02d4-e72f-7298-9a8f-12905cc4ca0d",
        "storage_key": "property/6767906449167016/019d02d4-e72f-7298-9a8f-12905cc4ca0d.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Charming apartment building entrance featuring abundant tropical plants, a welcoming bench, and manicured landscaping, creating a serene atmosphere.",
      "link": "",
      "alt_text": "Apartment building entrance with lush greenery and a bench with floral cushions.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_856e9c0e-2659-4bc4-8b03-b6fcf62382ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-e2ca-76e3-ba1a-9c05fa3fa529.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with lush landscaping and a walkway.",
        "public_id": "019d02d4-e2ca-76e3-ba1a-9c05fa3fa529",
        "storage_key": "property/6767906449167016/019d02d4-e2ca-76e3-ba1a-9c05fa3fa529.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy the vibrant greenery and well-maintained grounds surrounding your new home. This community offers a beautiful outdoor environment.",
      "link": "",
      "alt_text": "Exterior view of apartment building with lush landscaping and a walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d12a71c-4101-4796-8dae-fa65bccb0474",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-d30b-74dc-8698-9d029f29839e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with walkways and lush landscaping.",
        "public_id": "019d02d4-d30b-74dc-8698-9d029f29839e",
        "storage_key": "property/6767906449167016/019d02d4-d30b-74dc-8698-9d029f29839e.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "A scenic view of the apartment complex, showcasing the charming exterior of the buildings surrounded by vibrant greenery and well-maintained walkways.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with walkways and lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0c8a433-6a43-4e11-ae11-3bef70d221f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-ca64-775f-b8db-2cfab10c8bd4.webp",
      "image_media": {
        "alt_text": "View of apartment buildings with a parking lot and walkway.",
        "public_id": "019d02d4-ca64-775f-b8db-2cfab10c8bd4",
        "storage_key": "property/6767906449167016/019d02d4-ca64-775f-b8db-2cfab10c8bd4.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings, showcasing the walkway, parking area, and lush landscaping.",
      "link": "",
      "alt_text": "View of apartment buildings with a parking lot and walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ac6ab1c-eaf6-401c-add0-84fb22b6bae2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-b654-77cf-885e-b3b7a73c1f17.webp",
      "image_media": {
        "alt_text": "Hot tub with stainless steel railings and a light blue tiled interior, surrounded by a concrete patio and a black metal fence.",
        "public_id": "019d02d4-b654-77cf-885e-b3b7a73c1f17",
        "storage_key": "property/6767906449167016/019d02d4-b654-77cf-885e-b3b7a73c1f17.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting hot tub, perfect for a soothing soak after a long day. Enjoy the refreshing water and tranquil atmosphere.",
      "link": "",
      "alt_text": "Hot tub with stainless steel railings and a light blue tiled interior, surrounded by a concrete patio and a black metal fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3feef60c-92d4-42cd-992c-893a33dd6fdc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-b120-7359-aca6-2c6ce870bc68.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and lush greenery.",
        "public_id": "019d02d4-b120-7359-aca6-2c6ce870bc68",
        "storage_key": "property/6767906449167016/019d02d4-b120-7359-aca6-2c6ce870bc68.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by tropical landscaping and comfortable lounge seating.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and lush greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e185f5ef-663d-40e4-a453-a1db19b08a9e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in the sparkling outdoor pool, a perfect oasis for relaxation and fun.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_573d65ca-c3f9-4c95-9fca-cdd66d07dbf0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-5439-705c-97c1-cd17a8cfdc6c.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with a couch, coffee table, dining table, and modern appliances.",
        "public_id": "01a0cf0b-5439-705c-97c1-cd17a8cfdc6c",
        "storage_key": "property/6767906449167016/01a0cf0b-5439-705c-97c1-cd17a8cfdc6c.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living and dining area, perfect for entertaining. Features a fully equipped kitchen with stainless steel appliances and ample cabinet space. Modern finishes and bright lighting create a welcoming atmosphere.",
      "link": "",
      "alt_text": "Spacious living room and kitchen area with a couch, coffee table, dining table, and modern appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ed329c82-bb3d-4a76-bcf7-ee9137c60364",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-431c-72e7-bef4-f5d00b18f3a8.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and a bed with striped bedding.",
        "public_id": "01a0cf0b-431c-72e7-bef4-f5d00b18f3a8",
        "storage_key": "property/6767906449167016/01a0cf0b-431c-72e7-bef4-f5d00b18f3a8.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a king-size bed, mirrored closet, and a view of the dining area through the open doorway.",
      "link": "",
      "alt_text": "Bedroom with mirrored closet doors and a bed with striped bedding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce8f752d-7d97-4325-a1e1-1f2844815584",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-3bc8-76aa-9eb2-2ff80e01af13.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a large window overlooking trees",
        "public_id": "01a0cf0b-3bc8-76aa-9eb2-2ff80e01af13",
        "storage_key": "property/6767906449167016/01a0cf0b-3bc8-76aa-9eb2-2ff80e01af13.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with a balcony, perfect for relaxing and entertaining. This apartment features modern finishes and ample natural light.",
      "link": "",
      "alt_text": "Living room and dining area with a large window overlooking trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5562c8c7-0c0b-4841-bf66-7b0c4d047108",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-5995-75df-8566-f437c5b9f342.webp",
      "image_media": {
        "alt_text": "Friends enjoying an outdoor dinner.",
        "public_id": "01a0cf0b-5995-75df-8566-f437c5b9f342",
        "storage_key": "property/6767906449167016/01a0cf0b-5995-75df-8566-f437c5b9f342.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Lifestyle",
      "description": "Gather your friends and family for an evening of good food and great company.",
      "link": "",
      "alt_text": "Friends enjoying an outdoor dinner.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_07c080e6-cfa1-425c-8b3d-f76a95f952ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0cf0b-3de4-7448-833e-acaf3c1d1509.webp",
      "image_media": {
        "alt_text": "Woman laughing while petting her golden retriever dog on a couch.",
        "public_id": "01a0cf0b-3de4-7448-833e-acaf3c1d1509",
        "storage_key": "property/6767906449167016/01a0cf0b-3de4-7448-833e-acaf3c1d1509.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Lifestyle",
      "description": "Enjoy life's simple pleasures with your furry friend by your side. Our pet-friendly community welcomes you and your beloved companions.",
      "link": "",
      "alt_text": "Woman laughing while petting her golden retriever dog on a couch.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_12cce1b2-8280-4dde-9df5-f1d1bcc4c702",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11a1b-638e-7189-bee5-a48f279c500d.webp",
      "image_media": {
        "alt_text": "Modern bedroom with king-size bed, dresser, and artwork.",
        "public_id": "01a11a1b-638e-7189-bee5-a48f279c500d",
        "storage_key": "property/6767906449167016/01a11a1b-638e-7189-bee5-a48f279c500d.webp",
        "width": 1536,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom. Features a king-size bed, elegant dresser, and modern artwork for a sophisticated living space.",
      "link": "",
      "alt_text": "Modern bedroom with king-size bed, dresser, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_007e8a00-7e84-4c61-aa4f-e06af61128ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11a1b-6201-71ce-8291-adf3656ba51e.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, and a walk-in closet.",
        "public_id": "01a11a1b-6201-71ce-8291-adf3656ba51e",
        "storage_key": "property/6767906449167016/01a11a1b-6201-71ce-8291-adf3656ba51e.webp",
        "width": 1536,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Wake up to comfort in this spacious bedroom, featuring a modern ceiling fan and ample storage in the walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, ceiling fan, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6c608a88-4334-4a30-88ca-cdc298dc5966",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11a1b-6011-738f-903b-74a53d74bd25.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with sink, mirror, and artwork.",
        "public_id": "01a11a1b-6011-738f-903b-74a53d74bd25",
        "storage_key": "property/6767906449167016/01a11a1b-6011-738f-903b-74a53d74bd25.webp",
        "width": 1536,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Refresh and rejuvenate in this spacious bathroom, featuring a sleek vanity, large mirror, and tasteful decor.",
      "link": "",
      "alt_text": "Modern bathroom vanity with sink, mirror, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2a19d612-9f23-4d9b-8dae-b4b5d7612623",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11a1b-3ed2-7599-917e-803968558a09.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with a sliding glass door leading to a balcony overlooking trees.",
        "public_id": "01a11a1b-3ed2-7599-917e-803968558a09",
        "storage_key": "property/6767906449167016/01a11a1b-3ed2-7599-917e-803968558a09.webp",
        "width": 1536,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Enjoy spacious living in this beautifully appointed apartment, featuring a combined living and dining area with a private balcony.",
      "link": "",
      "alt_text": "Modern living and dining area with a sliding glass door leading to a balcony overlooking trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_511539a7-d2bb-447d-88e9-36b29d805ede",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11a1b-3eda-717e-903e-3068a2949926.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large sink.",
        "public_id": "01a11a1b-3eda-717e-903e-3068a2949926",
        "storage_key": "property/6767906449167016/01a11a1b-3eda-717e-903e-3068a2949926.webp",
        "width": 1536,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Experience effortless cooking in this modern kitchen, featuring sleek white cabinetry, premium stainless steel appliances, and a spacious sink.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dde5daaf-9a0a-47e7-a6ea-4866d39d3186",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11a1b-3d45-774e-86bb-49e15ed7dd20.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a single vanity, toilet, and shower with a curtain.",
        "public_id": "01a11a1b-3d45-774e-86bb-49e15ed7dd20",
        "storage_key": "property/6767906449167016/01a11a1b-3d45-774e-86bb-49e15ed7dd20.webp",
        "width": 1536,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Bright and clean bathroom featuring a white vanity with a sleek faucet, a modern toilet, and a shower/tub combo with a grey curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a single vanity, toilet, and shower with a curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_421d6d8e-c48c-4d75-af04-96f725680802",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11a1b-3d50-717c-849f-0982a0b90415.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with a sofa, coffee table, dining set, and stainless steel appliances.",
        "public_id": "01a11a1b-3d50-717c-849f-0982a0b90415",
        "storage_key": "property/6767906449167016/01a11a1b-3d50-717c-849f-0982a0b90415.webp",
        "width": 1536,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed apartment featuring a spacious living area seamlessly connected to a modern kitchen. Enjoy the convenience of stainless steel appliances and ample dining space.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with a sofa, coffee table, dining set, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_564185e4-807d-4294-9dda-6d315899be20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0c9b4-8469-7597-84e0-f2a2c6975f7d.webp",
      "image_media": {
        "alt_text": "Three people sit on a rocky outcrop watching a sunset over a valley.",
        "public_id": "01a0c9b4-8469-7597-84e0-f2a2c6975f7d",
        "storage_key": "property/6767906449167016/01a0c9b4-8469-7597-84e0-f2a2c6975f7d.webp",
        "width": 1920,
        "height": 1393
      },
      "title": "Lifestyle",
      "description": "Experience breathtaking sunsets and stunning natural beauty right outside your door. Our community offers a unique lifestyle that connects you with the outdoors.",
      "link": "",
      "alt_text": "Three people sit on a rocky outcrop watching a sunset over a valley.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4437af76-90dd-40d4-af9c-842f8aac979b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11bcd-f21a-771f-9bd3-04595cd5dc86.webp",
      "image_media": {
        "alt_text": "Person and dog sitting on a mountain overlooking a sunset.",
        "public_id": "01a11bcd-f21a-771f-9bd3-04595cd5dc86",
        "storage_key": "property/6767906449167016/01a11bcd-f21a-771f-9bd3-04595cd5dc86.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Lifestyle",
      "description": "Embrace the great outdoors with your furry friend. Our pet-friendly community offers the perfect blend of comfort and adventure.",
      "link": "",
      "alt_text": "Person and dog sitting on a mountain overlooking a sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c9c4aad-cc34-4ba1-a762-e316b45c54ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11bcd-e9b2-736c-a9a8-1c5e5712c60c.webp",
      "image_media": {
        "alt_text": "People watching a sunset over a city from a hilltop.",
        "public_id": "01a11bcd-e9b2-736c-a9a8-1c5e5712c60c",
        "storage_key": "property/6767906449167016/01a11bcd-e9b2-736c-a9a8-1c5e5712c60c.webp",
        "width": 1920,
        "height": 1421
      },
      "title": "Lifestyle",
      "description": "Enjoy breathtaking sunset views with friends and family from your elevated vantage point. Experience the beauty of nature and community.",
      "link": "",
      "alt_text": "People watching a sunset over a city from a hilltop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_27c1daa6-0384-4b78-8a5f-54b19cfc8ae6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11bcd-7050-76ba-9f13-35ce437dd7e0.webp",
      "image_media": {
        "alt_text": "Woman and dog hiking on a mountain trail with a man in the background.",
        "public_id": "01a11bcd-7050-76ba-9f13-35ce437dd7e0",
        "storage_key": "property/6767906449167016/01a11bcd-7050-76ba-9f13-35ce437dd7e0.webp",
        "width": 1920,
        "height": 1076
      },
      "title": "Lifestyle",
      "description": "Enjoy an active lifestyle with your furry friend. Explore scenic hiking trails just moments from your door.",
      "link": "",
      "alt_text": "Woman and dog hiking on a mountain trail with a man in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b712576d-b95e-40d1-9008-019a80213b87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0ce79-48d5-73ee-94c2-4cc2f498eac5.webp",
      "image_media": {
        "alt_text": "Family hiking with dogs on a mountain trail",
        "public_id": "01a0ce79-48d5-73ee-94c2-4cc2f498eac5",
        "storage_key": "property/6767906449167016/01a0ce79-48d5-73ee-94c2-4cc2f498eac5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Lifestyle",
      "description": "Enjoy the outdoors with your furry friends. Explore nearby hiking trails and embrace an active, pet-friendly lifestyle.",
      "link": "",
      "alt_text": "Family hiking with dogs on a mountain trail",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a2233531-5b52-433a-afbf-f06919e8bf89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0ce79-46f1-74e2-9fa2-4086163054a8.webp",
      "image_media": {
        "alt_text": "Woman meditating in a living room",
        "public_id": "01a0ce79-46f1-74e2-9fa2-4086163054a8",
        "storage_key": "property/6767906449167016/01a0ce79-46f1-74e2-9fa2-4086163054a8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Lifestyle",
      "description": "Find your inner peace. Our apartments offer a serene environment perfect for relaxation and mindfulness.",
      "link": "",
      "alt_text": "Woman meditating in a living room",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_990c4bbb-b9d8-44b7-afe5-8c2af60b60d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11bd1-7f68-73ce-bf3c-aa0770358340.webp",
      "image_media": {
        "alt_text": "Exterior view of apartments with a tree and walkway.",
        "public_id": "01a11bd1-7f68-73ce-bf3c-aa0770358340",
        "storage_key": "property/6767906449167016/01a11bd1-7f68-73ce-bf3c-aa0770358340.webp",
        "width": 1800,
        "height": 1198
      },
      "title": "Community",
      "description": "Walkway and grassy areas surrounding the apartment buildings, with lush trees and greenery.",
      "link": "",
      "alt_text": "Exterior view of apartments with a tree and walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_43e76ba2-240c-4db5-8f83-f52f280208eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11bd1-77d2-76af-8b71-110e464e39ed.webp",
      "image_media": {
        "alt_text": "View of a parking lot from a balcony with trees and blue sky.",
        "public_id": "01a11bd1-77d2-76af-8b71-110e464e39ed",
        "storage_key": "property/6767906449167016/01a11bd1-77d2-76af-8b71-110e464e39ed.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Apartment",
      "description": "Enjoy the scenic views of the surrounding greenery and blue sky from your private balcony, overlooking the convenient parking area.",
      "link": "",
      "alt_text": "View of a parking lot from a balcony with trees and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f7c21c4d-c05b-4e8b-a825-535085c87cbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11bcf-d0f3-7629-91eb-0dc02f40fa80.webp",
      "image_media": {
        "alt_text": "Exterior balcony with a lattice railing and a wall-mounted light fixture.",
        "public_id": "01a11bcf-d0f3-7629-91eb-0dc02f40fa80",
        "storage_key": "property/6767906449167016/01a11bcf-d0f3-7629-91eb-0dc02f40fa80.webp",
        "width": 1800,
        "height": 1198
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony, featuring a decorative lattice railing and ambient outdoor lighting, perfect for relaxing evenings.",
      "link": "",
      "alt_text": "Exterior balcony with a lattice railing and a wall-mounted light fixture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_726e6787-3f0b-4af4-b44f-c6a189ce15e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11a1b-62c7-721f-90bf-6d32b08de8d3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to a building.",
        "public_id": "01a11a1b-62c7-721f-90bf-6d32b08de8d3",
        "storage_key": "property/6767906449167016/01a11a1b-62c7-721f-90bf-6d32b08de8d3.webp",
        "width": 472,
        "height": 591
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas for your enjoyment.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to a building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b778d2c8-dfb1-4d15-b3d0-8f42ac743fc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-5787-74b8-b1c5-02c7d9cb2096.webp",
      "image_media": {
        "alt_text": "Parking lot with many cars and lush green trees.",
        "public_id": "019f8684-5787-74b8-b1c5-02c7d9cb2096",
        "storage_key": "property/6767906449167016/019f8684-5787-74b8-b1c5-02c7d9cb2096.webp",
        "width": 1536,
        "height": 960
      },
      "title": "Community",
      "description": "This expansive parking lot offers ample space for residents and guests, surrounded by beautiful green trees and landscaping.",
      "link": "",
      "alt_text": "Parking lot with many cars and lush green trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4b38ebfe-3d0f-4da9-83d6-39b3d10c22df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-0f25-7068-966e-7735155589f4.webp",
      "image_media": {
        "alt_text": "Exterior of the building with a large rock in the foreground and an American flag.",
        "public_id": "019d02d5-0f25-7068-966e-7735155589f4",
        "storage_key": "property/6767906449167016/019d02d5-0f25-7068-966e-7735155589f4.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "The exterior of the apartment building, featuring a welcoming entrance and lush green lawns, with a large rock adding a natural element to the landscape.",
      "link": "",
      "alt_text": "Exterior of the building with a large rock in the foreground and an American flag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_91eb6ec3-148f-4666-87ba-34516ff76ed1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11bd4-82e3-764b-b78d-22c26232f032.webp",
      "image_media": {
        "alt_text": "Shuffleboard court with lush landscaping and building exterior in the background.",
        "public_id": "01a11bd4-82e3-764b-b78d-22c26232f032",
        "storage_key": "property/6767906449167016/01a11bd4-82e3-764b-b78d-22c26232f032.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy a friendly game on the shuffleboard court, surrounded by beautiful tropical plants and the welcoming exterior of the community buildings. Perfect for leisure and outdoor fun.",
      "link": "",
      "alt_text": "Shuffleboard court with lush landscaping and building exterior in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d58a9a7-0339-4d5e-911e-138ef02b99f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11bd4-81fb-772b-9e45-2c204fe3baa1.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a11bd4-81fb-772b-9e45-2c204fe3baa1",
        "storage_key": "property/6767906449167016/01a11bd4-81fb-772b-9e45-2c204fe3baa1.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush greenery and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b13993eb-9c80-40df-b213-6331f4df7b51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11bd4-1fb4-70d9-afe5-a9d1ec2cb1b4.webp",
      "image_media": {
        "alt_text": "A paved walkway bordered by lush greenery and a black metal railing, leading past apartment buildings.",
        "public_id": "01a11bd4-1fb4-70d9-afe5-a9d1ec2cb1b4",
        "storage_key": "property/6767906449167016/01a11bd4-1fb4-70d9-afe5-a9d1ec2cb1b4.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy a stroll through our beautifully landscaped grounds, featuring vibrant tropical plants and well-maintained pathways. A perfect setting for relaxation and enjoying the outdoors.",
      "link": "",
      "alt_text": "A paved walkway bordered by lush greenery and a black metal railing, leading past apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7007c5fc-0142-49d7-8bd6-5da3061fe491",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11bd4-11e3-7049-993b-4b4f6dfe2376.webp",
      "image_media": {
        "alt_text": "Pathway through a community courtyard with lush greenery and buildings in the background.",
        "public_id": "01a11bd4-11e3-7049-993b-4b4f6dfe2376",
        "storage_key": "property/6767906449167016/01a11bd4-11e3-7049-993b-4b4f6dfe2376.webp",
        "width": 1920,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy a stroll through our beautifully landscaped courtyards, surrounded by vibrant greenery and well-maintained pathways.",
      "link": "",
      "alt_text": "Pathway through a community courtyard with lush greenery and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57747fae-93a5-4439-9838-250b37e33d8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a11a1b-63f2-706b-923d-9244b2010452.webp",
      "image_media": {
        "alt_text": "Exterior view of a two-story apartment building with balconies and lush landscaping.",
        "public_id": "01a11a1b-63f2-706b-923d-9244b2010452",
        "storage_key": "property/6767906449167016/01a11a1b-63f2-706b-923d-9244b2010452.webp",
        "width": 352,
        "height": 296
      },
      "title": "Community",
      "description": "Charming exterior view of a two-story apartment building, showcasing individual balconies and vibrant, well-maintained landscaping, creating an inviting curb appeal.",
      "link": "",
      "alt_text": "Exterior view of a two-story apartment building with balconies and lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f159f927-3d0a-431e-bdf4-10dcf050ab0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/01a0c9b2-81ef-7479-bc2a-72f4ab11014a.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings nestled against a hillside with a mountain backdrop at sunset.",
        "public_id": "01a0c9b2-81ef-7479-bc2a-72f4ab11014a",
        "storage_key": "property/6767906449167016/01a0c9b2-81ef-7479-bc2a-72f4ab11014a.webp",
        "width": 1920,
        "height": 1691
      },
      "title": "Community",
      "description": "Experience a vibrant community atmosphere with stunning views. Our apartment complex is situated in a picturesque landscape, offering a serene and beautiful living environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings nestled against a hillside with a mountain backdrop at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_001b5bf9-4fce-403f-b01f-3277023443ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a4ac-701c-af1a-2a779fcb1497.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and a swimming pool with mountains in the background.",
        "public_id": "019d02d4-a4ac-701c-af1a-2a779fcb1497",
        "storage_key": "property/6767906449167016/019d02d4-a4ac-701c-af1a-2a779fcb1497.webp",
        "width": 1800,
        "height": 1350
      },
      "title": "Community",
      "description": "Experience resort-style living with our sparkling swimming pool, surrounded by lush landscaping and beautiful mountain views. Enjoy the best of community amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and a swimming pool with mountains in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6d446fc1-0613-473a-8b37-09c4540ac0aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a132-701d-84de-30ec1a4dfc7f.webp",
      "image_media": {
        "alt_text": "Aerial view of a residential neighborhood adjacent to a lake and golf course.",
        "public_id": "019d02d4-a132-701d-84de-30ec1a4dfc7f",
        "storage_key": "property/6767906449167016/019d02d4-a132-701d-84de-30ec1a4dfc7f.webp",
        "width": 1920,
        "height": 1438
      },
      "title": "Community",
      "description": "Discover a vibrant community nestled beside a serene lake and a lush golf course, offering a picturesque setting for modern living.",
      "link": "",
      "alt_text": "Aerial view of a residential neighborhood adjacent to a lake and golf course.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1859b8f8-eed4-4087-85d1-566f635da150",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-3b9b-73d9-82f8-27977f62b37d.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and a ceiling fan.",
        "public_id": "019f8684-3b9b-73d9-82f8-27977f62b37d",
        "storage_key": "property/6767906449167016/019f8684-3b9b-73d9-82f8-27977f62b37d.webp",
        "width": 1536,
        "height": 1022
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a modern ceiling fan and ample storage with mirrored closet doors.",
      "link": "",
      "alt_text": "Bedroom with mirrored closet doors and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e8566a5e-6a5e-4612-904a-a5002634505c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-3550-7171-b741-9e6e8d15dad4.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and a ceiling fan.",
        "public_id": "019f8684-3550-7171-b741-9e6e8d15dad4",
        "storage_key": "property/6767906449167016/019f8684-3550-7171-b741-9e6e8d15dad4.webp",
        "width": 1536,
        "height": 1022
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring mirrored closet doors, a ceiling fan, and a view of the balcony.",
      "link": "",
      "alt_text": "Bedroom with mirrored closet doors and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8dee4486-1fe2-4302-9c2a-28110d763f66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8684-3299-7333-b000-c77e717d63a3.webp",
      "image_media": {
        "alt_text": "Bright living room with a sliding glass door leading to a balcony and a ceiling fan.",
        "public_id": "019f8684-3299-7333-b000-c77e717d63a3",
        "storage_key": "property/6767906449167016/019f8684-3299-7333-b000-c77e717d63a3.webp",
        "width": 1536,
        "height": 1022
      },
      "title": "Apartment",
      "description": "Spacious living area with natural light and a private balcony, perfect for relaxation and enjoying the view.",
      "link": "",
      "alt_text": "Bright living room with a sliding glass door leading to a balcony and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_906096ac-71b1-483e-b826-cbb904a6d240",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "The Trails Eatery",
      "poi_type": "Restaurants",
      "poi_address": "7389 Jackson Dr, San Diego, CA 92119, USA",
      "poi_short_description": "Elevated diner fare & gluten-free brunches served in a sleek, modern space inside a strip mall.",
      "poi_long_description": "Elevated diner fare & gluten-free brunches served in a sleek, modern space inside a strip mall.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-c915-754b-af2b-8f65d1e84e00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-c915-754b-af2b-8f65d1e84e00",
        "storage_key": "property/6767906449167016/019d02d5-c915-754b-af2b-8f65d1e84e00.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thetrailseatery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3023426030027562539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-trails-eatery",
      "poi_latitude": "32.8029207",
      "poi_longitude": "-117.0439079",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-667-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f7-740b-97ea-85e55ff9cfb8",
        "storage_key": "property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxWcVd0hW2YARK152nPRd9Sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_8b887c2e-5bca-41b1-a9b2-260264ba0ff7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Mountain Mike's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "7377 Jackson Dr, San Diego, CA 92119, USA",
      "poi_short_description": "Casual pizza chain featuring traditional pies, gluten-free crust & assorted appetizers.",
      "poi_long_description": "Casual pizza chain featuring traditional pies, gluten-free crust & assorted appetizers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-c910-72a8-919e-15a3f9d428b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-c910-72a8-919e-15a3f9d428b3",
        "storage_key": "property/6767906449167016/019d02d5-c910-72a8-919e-15a3f9d428b3.webp",
        "width": 838,
        "height": 815
      },
      "poi_business_url": "https://www.mountainmikespizza.com/locations/san-diego-jackson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17204494496288953989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-mikes-pizza",
      "poi_latitude": "32.8028364",
      "poi_longitude": "-117.0438148",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-469-6453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f7-740b-97ea-85e55ff9cfb8",
        "storage_key": "property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7tE1EdW2YARhVZ3T5ekwu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_2a8c278c-1dda-4dff-955e-4ab41ef16e5c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Primos Mexican Food",
      "poi_type": "Restaurants",
      "poi_address": "7343 Jackson Dr, San Diego, CA 92119, USA",
      "poi_short_description": "Oversized burritos & other Mexican eats are the focus of this counter-serve chain.",
      "poi_long_description": "Oversized burritos & other Mexican eats are the focus of this counter-serve chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-c9da-716d-9c09-d7e3625b553f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-c9da-716d-9c09-d7e3625b553f",
        "storage_key": "property/6767906449167016/019d02d5-c9da-716d-9c09-d7e3625b553f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://primosmex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17450115639223848738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primos-mexican-food",
      "poi_latitude": "32.8020323",
      "poi_longitude": "-117.0430179",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-698-8226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f7-740b-97ea-85e55ff9cfb8",
        "storage_key": "property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqUpwj0hW2YARIg9tHbhDK_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_d82126f8-5c0f-41d3-af3d-8154cd58015f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Cotijas Taco Shop",
      "poi_type": "Restaurants",
      "poi_address": "7285 Navajo Rd, San Diego, CA 92119, USA",
      "poi_short_description": "Tacos & other Mexican fast-food offerings are served at this casual counter-serve establishment.",
      "poi_long_description": "Tacos & other Mexican fast-food offerings are served at this casual counter-serve establishment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-c995-7571-8386-c953398b0182.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-c995-7571-8386-c953398b0182",
        "storage_key": "property/6767906449167016/019d02d5-c995-7571-8386-c953398b0182.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6126503650096503052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cotijas-taco-shop",
      "poi_latitude": "32.8040574",
      "poi_longitude": "-117.0388736",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-465-9490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f7-740b-97ea-85e55ff9cfb8",
        "storage_key": "property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZa7Jj0lW2YARDNkiM5y2BVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_9edbeb69-9bd1-4174-a27a-f14d7f093b6f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Brothers' Giant Pizza",
      "poi_type": "Restaurants",
      "poi_address": "6690 Mission Gorge Rd I, San Diego, CA 92120, USA",
      "poi_short_description": "Pizza, subs, and salads offered for delivery from this casual joint in the Golfview Center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-cf92-760b-9c53-3e85d257ce7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-cf92-760b-9c53-3e85d257ce7e",
        "storage_key": "property/6767906449167016/019d02d5-cf92-760b-9c53-3e85d257ce7e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.brosgiantpizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15717183406577708680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brothers-giant-pizza",
      "poi_latitude": "32.794324",
      "poi_longitude": "-117.097475",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-906-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f7-740b-97ea-85e55ff9cfb8",
        "storage_key": "property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5t_L-pV2YARiG66-ginHto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_bbc53b1b-2676-40f2-b714-98bee5995790",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Emiliano's Mexican Restaurant and Cantina",
      "poi_type": "Restaurants",
      "poi_address": "6690 Mission Gorge Rd, San Diego, CA 92120, USA",
      "poi_short_description": "Warm, vibrant Mexican eatery offering tacos, burritos & margaritas, plus happy-hour specials.",
      "poi_long_description": "Warm, vibrant Mexican eatery offering tacos, burritos & margaritas, plus happy-hour specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-d0d5-74ba-8462-568b3466c68a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-d0d5-74ba-8462-568b3466c68a",
        "storage_key": "property/6767906449167016/019d02d5-d0d5-74ba-8462-568b3466c68a.webp",
        "width": 1280,
        "height": 1043
      },
      "poi_business_url": "https://www.emilianosrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2120186011402060805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emilianos-mexican-restaurant-and-cantina",
      "poi_latitude": "32.7942554",
      "poi_longitude": "-117.097505",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-284-2460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f7-740b-97ea-85e55ff9cfb8",
        "storage_key": "property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6aDVO-pV2YARBURfs_FpbB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b4ce276f-ef32-4679-91f0-45ec87133d6b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Mona's Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5156 Waring Rd, San Diego, CA 92120, USA",
      "poi_short_description": "Family-owned spot supplying Italian standards such as pizza & lasagna in a modest room with booths.",
      "poi_long_description": "Family-owned spot supplying Italian standards such as pizza & lasagna in a modest room with booths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-d09b-71bc-978b-f1fc059c5427.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-d09b-71bc-978b-f1fc059c5427",
        "storage_key": "property/6767906449167016/019d02d5-d09b-71bc-978b-f1fc059c5427.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://monasitalianrestaurantmenu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8586627161364345622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monas-italian-restaurant",
      "poi_latitude": "32.792037",
      "poi_longitude": "-117.081922",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 619-286-2242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f7-740b-97ea-85e55ff9cfb8",
        "storage_key": "property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwgsI99V2YARFrPXy-jTKXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_ce19daf4-fe89-41aa-b7f9-c375d1ee510c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "SOBREMESA",
      "poi_type": "Restaurants",
      "poi_address": "8622 Lake Murray Blvd, San Diego, CA 92119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-d168-71fa-a00b-0a9d0c615cb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-d168-71fa-a00b-0a9d0c615cb2",
        "storage_key": "property/6767906449167016/019d02d5-d168-71fa-a00b-0a9d0c615cb2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sobremesasd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17157652700368012506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sobremesa",
      "poi_latitude": "32.8005177",
      "poi_longitude": "-117.0129007",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-439-6879",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f7-740b-97ea-85e55ff9cfb8",
        "storage_key": "property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR-IhdLlX2YAR2gT10Dk6HO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "latin_american_restaurant"
    },
    {
      "id": "custom_b112ec04-6933-42b6-b60d-93dd38907c77",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "CUPPA CUPPA COFFEE COMPANY",
      "poi_type": "Restaurants",
      "poi_address": "6606 Mission Gorge Rd, San Diego, CA 92120, USA",
      "poi_short_description": "Trendy coffee shop offering a great tea selection in Allied Gardens' Village Square.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-d66f-776b-8f2a-4fb429480d40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-d66f-776b-8f2a-4fb429480d40",
        "storage_key": "property/6767906449167016/019d02d5-d66f-776b-8f2a-4fb429480d40.webp",
        "width": 1280,
        "height": 1235
      },
      "poi_business_url": "http://www.cuppacuppacoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3773029582748479095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cuppa-cuppa-coffee-company",
      "poi_latitude": "32.7930849",
      "poi_longitude": "-117.0979274",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-852-4959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49eb-76b7-abbe-21e3c996555e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49eb-76b7-abbe-21e3c996555e",
        "storage_key": "property/6767906449167016/019d02d6-49eb-76b7-abbe-21e3c996555e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJz-IVGepV2YARd27DRmp-XDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_d60d0574-9977-4e59-a4bd-610f8676b8ba",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Hi!Dumplings",
      "poi_type": "Restaurants",
      "poi_address": "6618 Mission Gorge Rd, San Diego, CA 92120, USA",
      "poi_short_description": "Casual restaurant offering a variety of dumplings, noodles, and other Chinese plates.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-d763-745b-976d-63651fcf01a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-d763-745b-976d-63651fcf01a9",
        "storage_key": "property/6767906449167016/019d02d5-d763-745b-976d-63651fcf01a9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://hidumplings2023.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=702802049486357468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hidumplings",
      "poi_latitude": "32.7934968",
      "poi_longitude": "-117.0983122",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-788-9995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f7-740b-97ea-85e55ff9cfb8",
        "storage_key": "property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJewfCxR5V2YAR3AMNi73awAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_bf353194-f496-4a1d-8001-86f3c17be5d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Chamorro Grill",
      "poi_type": "Restaurants",
      "poi_address": "6628 Mission Gorge Rd C, San Diego, CA 92120, USA",
      "poi_short_description": "Colorful eatery offering casual Chamorro food, which combines Filipino & other island dishes.",
      "poi_long_description": "Colorful eatery offering casual Chamorro food, which combines Filipino & other island dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-d783-7744-b61d-905f580e8ca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-d783-7744-b61d-905f580e8ca9",
        "storage_key": "property/6767906449167016/019d02d5-d783-7744-b61d-905f580e8ca9.webp",
        "width": 1079,
        "height": 1079
      },
      "poi_business_url": "http://chamorrogrillsd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8482097730301384346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chamorro-grill",
      "poi_latitude": "32.793661",
      "poi_longitude": "-117.097865",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-280-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f7-740b-97ea-85e55ff9cfb8",
        "storage_key": "property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn82RIepV2YARmtbCFPJ2tnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_497373c7-62c7-4291-bea4-20a5cc6f7e1b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Good Pressure Brewing Co.",
      "poi_type": "Restaurants",
      "poi_address": "7559 Mission Gorge Rd, San Diego, CA 92120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-d8fe-767a-b132-09179eb24d8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-d8fe-767a-b132-09179eb24d8b",
        "storage_key": "property/6767906449167016/019d02d5-d8fe-767a-b132-09179eb24d8b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://goodpressurebrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14261219788615534350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "good-pressure-brewing-co",
      "poi_latitude": "32.807251",
      "poi_longitude": "-117.0760628",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 619-310-6608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP5EjSFtX2YARDkczrNYH6sU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_842c7f21-1c56-4704-bc08-31b0dcf02e0f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "8508 San Carlos Dr, San Diego, CA 92119, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-dd4a-701e-9a4d-aac10c23d394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-dd4a-701e-9a4d-aac10c23d394",
        "storage_key": "property/6767906449167016/019d02d5-dd4a-701e-9a4d-aac10c23d394.webp",
        "width": 1280,
        "height": 1039
      },
      "poi_business_url": "https://www.7-eleven.com/locations/ca/san-diego/8508-san-carlos-dr-13650?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10231289491758097836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "32.8005441",
      "poi_longitude": "-117.013731",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-463-2228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-7d5697fd421b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-7d5697fd421b",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-7d5697fd421b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJORwuW6NX2YARrKVtxpXX_I0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_c1a30bd1-0b45-4b43-9e15-81556ab67c35",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Express Gas Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "8602 Lake Murray Blvd, San Diego, CA 92119, USA",
      "poi_short_description": "Gas station providing diesel and gas, and notable for its cheap prices and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-dea2-71fc-b112-ecc6063aac20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-dea2-71fc-b112-ecc6063aac20",
        "storage_key": "property/6767906449167016/019d02d5-dea2-71fc-b112-ecc6063aac20.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13399967003036624474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "express-gas-mart",
      "poi_latitude": "32.8000606",
      "poi_longitude": "-117.0132446",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-461-5721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-4edc-7638-8b64-3c93691512fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-4edc-7638-8b64-3c93691512fe",
        "storage_key": "property/6767906449167016/019d02d6-4edc-7638-8b64-3c93691512fe.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJoyF6a6NX2YARWib0Qf4-9rk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_ad6b1f05-9914-4a77-8552-d5e5a53eb033",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Albertsons",
      "poi_type": "Shopping & Retail",
      "poi_address": "8650 Lake Murray Blvd, San Diego, CA 92119, USA",
      "poi_short_description": "Retail grocery chain store, bakery, deli and butcher's offering everything from meat and seafood to cakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-df72-76bc-a2db-c5407209f2f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-df72-76bc-a2db-c5407209f2f5",
        "storage_key": "property/6767906449167016/019d02d5-df72-76bc-a2db-c5407209f2f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.albertsons.com/ca/san-diego/8650-lake-murray-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7358873359652567283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albertsons",
      "poi_latitude": "32.8016147",
      "poi_longitude": "-117.0132525",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 619-697-8896",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-4ee7-75fd-a05f-7b9a0bc7f7ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-4ee7-75fd-a05f-7b9a0bc7f7ba",
        "storage_key": "property/6767906449167016/019d02d6-4ee7-75fd-a05f-7b9a0bc7f7ba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCxnkLqNX2YAR8zgt5VT4H2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_88ccb466-c567-42f5-9737-dd9ff25e9b48",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "8766 Navajo Rd, San Diego, CA 92119, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-e061-747d-a1c3-8453f9a7f7f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-e061-747d-a1c3-8453f9a7f7f5",
        "storage_key": "property/6767906449167016/019d02d5-e061-747d-a1c3-8453f9a7f7f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8766+navajo+rd-san+diego-ca-92119/id=7176",
      "poi_directions_map_url": "https://maps.google.com/?cid=10983829756725687772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.8033804",
      "poi_longitude": "-117.0087811",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-667-8764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7Jo4pdX2YAR3PX_Cvhmbpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_c1da676f-4607-4172-8bf8-c2bdf716db00",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Einstein Bros. Bagels",
      "poi_type": "Shopping & Retail",
      "poi_address": "8736 Lake Murray Blvd, San Diego, CA 92119, USA",
      "poi_short_description": "Chain neighborhood bakery crafting freshly baked bagels and breakfast sandwiches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-e42d-7334-b57e-d1eabaebbabc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-e42d-7334-b57e-d1eabaebbabc",
        "storage_key": "property/6767906449167016/019d02d5-e42d-7334-b57e-d1eabaebbabc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.einsteinbros.com/us/ca/san-diego/8736-lake-murray-blvd?y_source=1_OTA1MDEyOS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5233079338886336888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "einstein-bros-bagels",
      "poi_latitude": "32.802832",
      "poi_longitude": "-117.0126296",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 619-697-2097",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f7-740b-97ea-85e55ff9cfb8",
        "storage_key": "property/6767906449167016/019d02d6-49f7-740b-97ea-85e55ff9cfb8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0C91aJX2YAReJHBw-6hn0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_ac229d47-e0e5-4805-93a7-c71c85a3d65e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Petco",
      "poi_type": "Shopping & Retail",
      "poi_address": "8501 Fletcher Pkwy, La Mesa, CA 91942, USA",
      "poi_short_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_long_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-e50b-74b0-9950-3607a2447ab7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-e50b-74b0-9950-3607a2447ab7",
        "storage_key": "property/6767906449167016/019d02d5-e50b-74b0-9950-3607a2447ab7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.petco.com/ca/lamesa/pet-supplies-lamesa-ca-1110.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3886445984341703894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petco",
      "poi_latitude": "32.7799899",
      "poi_longitude": "-117.0143622",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 619-337-0701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-4f54-718e-a6e3-6e0c02476521.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-4f54-718e-a6e3-6e0c02476521",
        "storage_key": "property/6767906449167016/019d02d6-4f54-718e-a6e3-6e0c02476521.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlYT0XJ9X2YAR1jxuDwhu7zU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_store"
    },
    {
      "id": "custom_21a11cbe-0b4d-4bc6-b84c-c24ed9b0b56c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Grossmont Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "5500 Grossmont Center Dr, La Mesa, CA 91942, USA",
      "poi_short_description": "Sizable shopping complex with department stores, chain retailers, casual eateries & a movie theater.",
      "poi_long_description": "Sizable shopping complex with department stores, chain retailers, casual eateries & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-e691-70bb-b9c7-e17acee68855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-e691-70bb-b9c7-e17acee68855",
        "storage_key": "property/6767906449167016/019d02d5-e691-70bb-b9c7-e17acee68855.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://grossmontcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13965393348966594737&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grossmont-center",
      "poi_latitude": "32.7779979",
      "poi_longitude": "-117.0113848",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 619-465-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-4f54-718e-a6e3-6e0c02476521.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-4f54-718e-a6e3-6e0c02476521",
        "storage_key": "property/6767906449167016/019d02d6-4f54-718e-a6e3-6e0c02476521.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoQKXwGxX2YARsbjBUUILz8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4e9cdd71-d847-4177-818b-6bcd608cd3fe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5500 Grossmont Center Dr BLDG P, La Mesa, CA 91942, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-e883-71db-bacc-a00ae352e51b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-e883-71db-bacc-a00ae352e51b",
        "storage_key": "property/6767906449167016/019d02d5-e883-71db-bacc-a00ae352e51b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/la-mesa-ca-pharmacies/5500-grossmont-center-dr-bldg-p-la-mesa-ca-91942/storeid=9169?WT.mc_id=LS_GOOGLE_RX_9169",
      "poi_directions_map_url": "https://maps.google.com/?cid=7170039122534580579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.7778712",
      "poi_longitude": "-117.0143977",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-462-9592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-4f2a-736a-8c6b-368da81f1511.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-4f2a-736a-8c6b-368da81f1511",
        "storage_key": "property/6767906449167016/019d02d6-4f2a-736a-8c6b-368da81f1511.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__9vrGxX2YARY8FT7JcYgWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e6f274e5-76c9-4457-af7f-7c96823ba409",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Navajo Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "8650 Lake Murray Blvd, San Diego, CA 92119, USA",
      "poi_short_description": "Shopping center with a supermarket, a pharmacy, dining options, and personal services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-ea8d-7222-b104-3fe99fe36dee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-ea8d-7222-b104-3fe99fe36dee",
        "storage_key": "property/6767906449167016/019d02d5-ea8d-7222-b104-3fe99fe36dee.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.regencycenters.com/property/detail/90009/Navajo-Shopping-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14421446700483893888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "navajo-shopping-center",
      "poi_latitude": "32.8018442",
      "poi_longitude": "-117.0125535",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 858-847-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-4f54-718e-a6e3-6e0c02476521.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-4f54-718e-a6e3-6e0c02476521",
        "storage_key": "property/6767906449167016/019d02d6-4f54-718e-a6e3-6e0c02476521.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCxnkLqNX2YARgFqSsV1FI8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c011c2a9-e608-4a27-ab45-5bffbee8ed48",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Gage Elementary School",
      "poi_type": "Education",
      "poi_address": "6811 Bisby Lake Ave, San Diego, CA 92119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-ebc9-7791-b53a-93aa43729245.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-ebc9-7791-b53a-93aa43729245",
        "storage_key": "property/6767906449167016/019d02d5-ebc9-7791-b53a-93aa43729245.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gage.sandiegounified.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13287237943875529425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gage-elementary-school",
      "poi_latitude": "32.8069209",
      "poi_longitude": "-117.0147919",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 858-988-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3foJUrlX2YAR0erK2oLAZbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_dfd80d27-3d64-4b52-99c8-fb774e5c85c5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Benchley-Weinberger Elementary",
      "poi_type": "Education",
      "poi_address": "6269 Twin Lake Dr, San Diego, CA 92119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-ece0-757c-89a3-bb6b32f780ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-ece0-757c-89a3-bb6b32f780ef",
        "storage_key": "property/6767906449167016/019d02d5-ece0-757c-89a3-bb6b32f780ef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://benchleyweinberger.sandiegounified.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2388720996743754583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benchley-weinberger-elementary",
      "poi_latitude": "32.794745",
      "poi_longitude": "-117.0320805",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 619-344-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiwOwS61X2YARV7NtLhdxJiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_38541238-63c3-469a-84a0-f75ed5e6edce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Pershing Middle School",
      "poi_type": "Education",
      "poi_address": "8204 San Carlos Dr, San Diego, CA 92119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://pershing.sandiegounified.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12020133854563654246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pershing-middle-school",
      "poi_latitude": "32.8020509",
      "poi_longitude": "-117.0213717",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 619-362-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ658YoLpX2YARZtrpKQ4Y0KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2b312222-6a33-468c-8a6e-39a577a2f13c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Patrick Henry High School",
      "poi_type": "Education",
      "poi_address": "6702 Wandermere Dr, San Diego, CA 92120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-eeb3-707a-a198-bb252aad7770.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-eeb3-707a-a198-bb252aad7770",
        "storage_key": "property/6767906449167016/019d02d5-eeb3-707a-a198-bb252aad7770.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://patrickhenryhs.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11586039931789379320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patrick-henry-high-school",
      "poi_latitude": "32.7978324",
      "poi_longitude": "-117.0517868",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 858-988-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPRf1xUFW2YAR-AbMt-7hyaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_cf7bf1f9-2064-49cf-8644-be2157b9d240",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Myron B. Green Elementary School",
      "poi_type": "Education",
      "poi_address": "7030 Wandermere Dr, San Diego, CA 92119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-f0dc-709b-92bf-114ace7ec369.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-f0dc-709b-92bf-114ace7ec369",
        "storage_key": "property/6767906449167016/019d02d5-f0dc-709b-92bf-114ace7ec369.webp",
        "width": 880,
        "height": 500
      },
      "poi_business_url": "https://green.sandiegounified.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7707044928310610473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "myron-b-green-elementary-school",
      "poi_latitude": "32.7966804",
      "poi_longitude": "-117.0454483",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-510-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3VEad0VW2YARKQruU4fs9Go",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d8747325-828a-4e3b-82f4-bd64af515cec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Ralph Dailard Elementary School",
      "poi_type": "Education",
      "poi_address": "6425 Cibola Rd, San Diego, CA 92120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-f2cc-7384-b23f-68386441738e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-f2cc-7384-b23f-68386441738e",
        "storage_key": "property/6767906449167016/019d02d5-f2cc-7384-b23f-68386441738e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://dailard.sandiegounified.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4137022734605475831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ralph-dailard-elementary-school",
      "poi_latitude": "32.8051222",
      "poi_longitude": "-117.0531444",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 619-860-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL1qPTD5W2YAR99_fG0KoaTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e32c1ee4-7991-4a00-b837-f276e99ebd3b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Millennial Tech Middle School",
      "poi_type": "Education",
      "poi_address": "1110 Carolina Ln, San Diego, CA 92102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-f40d-70ab-a955-081230c6b938.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-f40d-70ab-a955-081230c6b938",
        "storage_key": "property/6767906449167016/019d02d5-f40d-70ab-a955-081230c6b938.webp",
        "width": 1181,
        "height": 554
      },
      "poi_business_url": "http://www.millennialtech.sandiegounified.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11685799376938070060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "millennial-tech-middle-school",
      "poi_latitude": "32.717278",
      "poi_longitude": "-117.088822",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 619-362-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg9swM-RT2YARLPDfip5MLKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d70b0749-e608-4934-9120-0acd8ba6e266",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Springall Academy k-12",
      "poi_type": "Education",
      "poi_address": "6460 Boulder Lake Ave, San Diego, CA 92119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.springall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4623442208458194839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springall-academy-k-12",
      "poi_latitude": "32.7989652",
      "poi_longitude": "-117.0186523",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 619-460-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw-hmJKVX2YARl7-ySjHEKUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_77b49e9a-0ddc-4edf-a65a-f68bc86ac2ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "San Carlos KinderCare",
      "poi_type": "Education",
      "poi_address": "7007 Golfcrest Dr, San Diego, CA 92119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-f515-75af-ad2b-e069f74a490e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-f515-75af-ad2b-e069f74a490e",
        "storage_key": "property/6767906449167016/019d02d5-f515-75af-ad2b-e069f74a490e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/san-diego/ca/300467?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3MjY0LTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=17421702796298896433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-carlos-kindercare",
      "poi_latitude": "32.8036362",
      "poi_longitude": "-117.0377642",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 619-461-5771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ79v4KkpW2YARMUTTm2NSxvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_49b2a4c9-7b49-44d9-95ae-8c7823dede52",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "San Diego State University",
      "poi_type": "Education",
      "poi_address": "5500 Campanile Dr, San Diego, CA 92182, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-f81b-7598-9130-6384cbbbc9a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-f81b-7598-9130-6384cbbbc9a3",
        "storage_key": "property/6767906449167016/019d02d5-f81b-7598-9130-6384cbbbc9a3.webp",
        "width": 1125,
        "height": 1074
      },
      "poi_business_url": "http://www.sdsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14096032391797864726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-diego-state-university",
      "poi_latitude": "32.77641210000001",
      "poi_longitude": "-117.0719191",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-594-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIUqgpoZW2YARFvmCv8Yqn8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_86bcf748-8135-4d5f-a204-f1ee4dc1907f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Reading Cinemas Grossmont with TITAN XC",
      "poi_type": "Entertainment",
      "poi_address": "5500 Grossmont Center Dr Suite 169, La Mesa, CA 91942, USA",
      "poi_short_description": "Multiplex for blockbuster, indie & classic films also features special family-oriented screenings.",
      "poi_long_description": "Multiplex for blockbuster, indie & classic films also features special family-oriented screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-f928-7253-8fa2-6ec5a9989a66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-f928-7253-8fa2-6ec5a9989a66",
        "storage_key": "property/6767906449167016/019d02d5-f928-7253-8fa2-6ec5a9989a66.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "https://www.readingcinemas.com/grossmont",
      "poi_directions_map_url": "https://maps.google.com/?cid=4581011639230303143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reading-cinemas-grossmont-with-titan-xc",
      "poi_latitude": "32.7786663",
      "poi_longitude": "-117.0106205",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-465-3040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-540b-767e-a165-722fb706a506.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-540b-767e-a165-722fb706a506",
        "storage_key": "property/6767906449167016/019d02d6-540b-767e-a165-722fb706a506.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-uCwRJX2YARp4tAjNAFkz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f587cca5-a233-490b-bf93-3e6eb52c1cc0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Viejas Arena",
      "poi_type": "Entertainment",
      "poi_address": "5500 Canyon Crest Dr, San Diego, CA 92182, USA",
      "poi_short_description": "12,000+ capacity venue for sports, concerts & events on the San Diego State University campus.",
      "poi_long_description": "12,000+ capacity venue for sports, concerts & events on the San Diego State University campus.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-fc8f-70b5-8e5a-3a48c7389c1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-fc8f-70b5-8e5a-3a48c7389c1c",
        "storage_key": "property/6767906449167016/019d02d5-fc8f-70b5-8e5a-3a48c7389c1c.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://as.sdsu.edu/viejas_arena/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5659767995776599249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "viejas-arena",
      "poi_latitude": "32.7740276",
      "poi_longitude": "-117.0746442",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-594-0234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJASLBHoFW2YAR0YRjYwGJi04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_0a464582-4347-4d30-a08f-9c8f2105a713",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "The Observatory North Park",
      "poi_type": "Entertainment",
      "poi_address": "2891 University Ave, San Diego, CA 92104, USA",
      "poi_short_description": "Restored circa-1939 theater has a red-decked cathedral hall for live music, plays, films & more.",
      "poi_long_description": "Restored circa-1939 theater has a red-decked cathedral hall for live music, plays, films & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-feeb-72fb-ba69-335ea809bb60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-feeb-72fb-ba69-335ea809bb60",
        "storage_key": "property/6767906449167016/019d02d5-feeb-72fb-ba69-335ea809bb60.webp",
        "width": 1280,
        "height": 880
      },
      "poi_business_url": "https://www.observatorysd.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=7569987623659765444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-observatory-north-park",
      "poi_latitude": "32.7480121",
      "poi_longitude": "-117.1313006",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 619-239-8836",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2eY6pPZU2YARxP5X3qL_DWk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_dabed5e0-1669-47be-b3e3-387b5524d99b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "San Diego Natural History Museum",
      "poi_type": "Entertainment",
      "poi_address": "1788 El Prado, San Diego, CA 92101, USA",
      "poi_short_description": "Large natural history museum with rotating displays on animals, dinosaurs & earth science.",
      "poi_long_description": "Large natural history museum with rotating displays on animals, dinosaurs & earth science.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-ff70-7007-a6ac-04fbb947d4b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-ff70-7007-a6ac-04fbb947d4b6",
        "storage_key": "property/6767906449167016/019d02d5-ff70-7007-a6ac-04fbb947d4b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sdnat.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12555214747688387195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-diego-natural-history-museum",
      "poi_latitude": "32.7323223",
      "poi_longitude": "-117.147364",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 619-232-3821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5417-76eb-9ed2-d61259796f3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5417-76eb-9ed2-d61259796f3f",
        "storage_key": "property/6767906449167016/019d02d6-5417-76eb-9ed2-d61259796f3f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJN0BfV5ZU2YARe0K26koVPa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_105926d7-2c52-47c4-beb8-c2de4b8649e0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Fleet Science Center",
      "poi_type": "Entertainment",
      "poi_address": "1875 El Prado, San Diego, CA 92101, USA",
      "poi_short_description": "Educational center with hands-on exhibits, a planetarium, an IMAX theater & interactive displays.",
      "poi_long_description": "Educational center with hands-on exhibits, a planetarium, an IMAX theater & interactive displays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-00f1-712b-b6c7-8a0636da1ffb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-00f1-712b-b6c7-8a0636da1ffb",
        "storage_key": "property/6767906449167016/019d02d6-00f1-712b-b6c7-8a0636da1ffb.webp",
        "width": 990,
        "height": 660
      },
      "poi_business_url": "https://www.fleetscience.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5762359400008584638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fleet-science-center",
      "poi_latitude": "32.7308009",
      "poi_longitude": "-117.1469593",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 619-238-1233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5417-76eb-9ed2-d61259796f3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5417-76eb-9ed2-d61259796f3f",
        "storage_key": "property/6767906449167016/019d02d6-5417-76eb-9ed2-d61259796f3f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJITml-JZU2YARvg2lEVgD-E8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d46ece50-65f7-488a-8d57-3000e0142c22",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "San Diego Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2920 Zoo Dr, San Diego, CA 92101, USA",
      "poi_short_description": "Zoo featuring giraffes, koalas, apes & more, plus tours & a conservation society.",
      "poi_long_description": "Zoo featuring giraffes, koalas, apes & more, plus tours & a conservation society.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-036a-77b9-8012-1efeb1edd49a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-036a-77b9-8012-1efeb1edd49a",
        "storage_key": "property/6767906449167016/019d02d6-036a-77b9-8012-1efeb1edd49a.webp",
        "width": 1280,
        "height": 1048
      },
      "poi_business_url": "https://zoo.sandiegozoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6769178757639299655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-diego-zoo",
      "poi_latitude": "32.7360353",
      "poi_longitude": "-117.1509849",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 619-231-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyYB_SZVU2YARR-I1Jjf08F0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_ec5135b3-b488-417f-bdcb-530a97457809",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Spanish Village Art Center",
      "poi_type": "Entertainment",
      "poi_address": "1770 Village Pl, San Diego, CA 92101, USA",
      "poi_short_description": "Colorful community with Spanish-style buildings & studios with works by local artists, plus classes.",
      "poi_long_description": "Colorful community with Spanish-style buildings & studios with works by local artists, plus classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-05c8-70c8-af08-77a686236d55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-05c8-70c8-af08-77a686236d55",
        "storage_key": "property/6767906449167016/019d02d6-05c8-70c8-af08-77a686236d55.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://villageartscenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15894659210500376196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spanish-village-art-center",
      "poi_latitude": "32.7332189",
      "poi_longitude": "-117.1474342",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 619-709-3540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTbIweJZU2YARhAbEo1Ysldw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fdb85cf2-1538-448b-ac70-ed9d3e5079da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "The Old Globe",
      "poi_type": "Entertainment",
      "poi_address": "1363 Old Globe Way, San Diego, CA 92101, USA",
      "poi_short_description": "Longtime theater with shows ranging from Shakespeare & classic musicals to first-run new plays.",
      "poi_long_description": "Longtime theater with shows ranging from Shakespeare & classic musicals to first-run new plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-0608-779f-8d7b-4ed8ec87930d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-0608-779f-8d7b-4ed8ec87930d",
        "storage_key": "property/6767906449167016/019d02d6-0608-779f-8d7b-4ed8ec87930d.webp",
        "width": 972,
        "height": 1280
      },
      "poi_business_url": "http://www.theoldglobe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7540525372830274283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-old-globe",
      "poi_latitude": "32.73220020000001",
      "poi_longitude": "-117.1521708",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 619-234-5623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJke_Sxr1U2YAR61JeC-BTpWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_a4d2e472-e516-484b-9705-a60e2d277bdd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Santee Swap Meet",
      "poi_type": "Entertainment",
      "poi_address": "10990 N Woodside Ave, Santee, CA 92071, USA",
      "poi_short_description": "Iconic spot for a double feature in the car or lawn chairs, complete with 2 screens & a snack bar.",
      "poi_long_description": "Iconic spot for a double feature in the car or lawn chairs, complete with 2 screens & a snack bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-0702-7378-bfea-dc1ad24d9a73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-0702-7378-bfea-dc1ad24d9a73",
        "storage_key": "property/6767906449167016/019d02d6-0702-7378-bfea-dc1ad24d9a73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.santeeswap.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8078750364497905889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santee-swap-meet",
      "poi_latitude": "32.8475921",
      "poi_longitude": "-116.9583995",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-4f54-718e-a6e3-6e0c02476521.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-4f54-718e-a6e3-6e0c02476521",
        "storage_key": "property/6767906449167016/019d02d6-4f54-718e-a6e3-6e0c02476521.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi673Bp_i24AR4Yj0SKd8HXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "flea_market"
    },
    {
      "id": "custom_ce2e804a-cb45-4220-80e5-d48d3a6ab2af",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Sharp Grossmont Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "5555 Grossmont Center Dr, La Mesa, CA 91942, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-096f-778c-bc88-945d84be41fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-096f-778c-bc88-945d84be41fc",
        "storage_key": "property/6767906449167016/019d02d6-096f-778c-bc88-945d84be41fc.webp",
        "width": 730,
        "height": 410
      },
      "poi_business_url": "https://www.sharp.com/locations/hospitals/sharp-grossmont?utm_source=google&utm_medium=organic&utm_campaign=yext&y_source=1_ODQ4MzMyNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10405628621323876698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sharp-grossmont-hospital",
      "poi_latitude": "32.781125",
      "poi_longitude": "-117.0074256",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-740-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5452-7036-86f5-2e07e15fd2dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5452-7036-86f5-2e07e15fd2dc",
        "storage_key": "property/6767906449167016/019d02d6-5452-7036-86f5-2e07e15fd2dc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-718aG1X2YARWrmlhhk4aJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f60f8718-6e8e-47d6-badd-a7b1b05e14ca",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Marque Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "6136 Lake Murray Blvd, La Mesa, CA 91942, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-0c92-7548-8554-a1b2599cdea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-0c92-7548-8554-a1b2599cdea4",
        "storage_key": "property/6767906449167016/019d02d6-0c92-7548-8554-a1b2599cdea4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://marquemedical.com/location/grossmont/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9167158625662535174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marque-urgent-care",
      "poi_latitude": "32.7910821",
      "poi_longitude": "-117.0212559",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 949-760-9222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQpidqhX2YARBgZGSjNKOH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_be278e80-02e2-486d-a177-f955f4a6cb2e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "7393 Jackson Dr, San Diego, CA 92119, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-0c53-706e-b8b8-780842d2580f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-0c53-706e-b8b8-780842d2580f",
        "storage_key": "property/6767906449167016/019d02d6-0c53-706e-b8b8-780842d2580f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-diego-ca-pharmacies/7393-jackson-dr-jackson-drive-and-navajo-road-san-diego-ca-92119/storeid=9137?WT.mc_id=LS_GOOGLE_FS_9137",
      "poi_directions_map_url": "https://maps.google.com/?cid=3744212510361381138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "32.8031648",
      "poi_longitude": "-117.044009",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-465-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYrd-7NX2YAREumpw3Ad9jM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_92087ed0-25b8-4adc-91cb-c3ea6b793110",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "San Carlos Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7439 Jackson Dr, San Diego, CA 92119, USA",
      "poi_short_description": "Family-owned fitness facility with an array of equipment, plus outdoor workout stations and a sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-0d39-72f5-8731-7fad3c9d632a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-0d39-72f5-8731-7fad3c9d632a",
        "storage_key": "property/6767906449167016/019d02d6-0d39-72f5-8731-7fad3c9d632a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7131431892668887007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-carlos-fitness",
      "poi_latitude": "32.80347",
      "poi_longitude": "-117.0452083",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-337-3759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6YeukkdW2YAR369rvoXv92I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_640b6c2f-33b4-4c52-8f70-a4a4ccaee270",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5500 Grossmont Center Dr, La Mesa, CA 91942, USA",
      "poi_short_description": "Spotless gym facility featuring free weights, machines, cardio equipment, tanning beds and saunas, plus group classes, personal training and massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-0f66-7187-9ef0-699aadb52f7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-0f66-7187-9ef0-699aadb52f7c",
        "storage_key": "property/6767906449167016/019d02d6-0f66-7187-9ef0-699aadb52f7c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/ca/la-mesa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5238529357656100914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "32.7764938",
      "poi_longitude": "-117.0114144",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 619-741-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDz1qQhJX2YARMhCMJLL-skg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a9820caf-d448-4f01-8810-88fd719ee15a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Pure Power PILATES + Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7434 Jackson Dr Suite B, San Diego, CA 92119, USA",
      "poi_short_description": "Friendly studio for pilates, stretching and other fitness classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-1317-7189-974e-27ccf8fff760.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-1317-7189-974e-27ccf8fff760",
        "storage_key": "property/6767906449167016/019d02d6-1317-7189-974e-27ccf8fff760.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://www.purepowerpilatessd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10182241261868517932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-power-pilates--fitness",
      "poi_latitude": "32.8029482",
      "poi_longitude": "-117.0461699",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-741-5885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5bnpV2xW2YARLIr_1nqWTo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_66926147-c78e-4841-b953-b0aed694bbcc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Beyond Pilates Studio, San Carlos",
      "poi_type": "Health and Wellness",
      "poi_address": "7189 Navajo Rd Site F, San Diego, CA 92119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-13bb-72ea-bbbd-f4d47d8e1c58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-13bb-72ea-bbbd-f4d47d8e1c58",
        "storage_key": "property/6767906449167016/019d02d6-13bb-72ea-bbbd-f4d47d8e1c58.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://beyondpilates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10479252371530347991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beyond-pilates-studio-san-carlos",
      "poi_latitude": "32.8035683",
      "poi_longitude": "-117.0405846",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-729-1774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr_2Zt0lW2YAR13W8rILIbZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_75ffe85c-7099-4c92-9620-4bc991c3c66d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "PhysioFixx Physical Therapy",
      "poi_type": "Health and Wellness",
      "poi_address": "7290 Navajo Rd #111, San Diego, CA 92119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-14cc-76a7-948e-1a47286a72b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-14cc-76a7-948e-1a47286a72b9",
        "storage_key": "property/6767906449167016/019d02d6-14cc-76a7-948e-1a47286a72b9.webp",
        "width": 991,
        "height": 1280
      },
      "poi_business_url": "http://www.physiofixxpt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18269507325914068368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "physiofixx-physical-therapy",
      "poi_latitude": "32.8045598",
      "poi_longitude": "-117.0381992",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 619-535-6964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdN6X3BX2YARkDWB7h1Uiv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "physiotherapist"
    },
    {
      "id": "custom_cbcb65b8-ced2-43e6-ae5f-fa5a5fbe3a3f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Cowles Mountain Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7001 Golfcrest Dr, San Diego, CA 92119, USA",
      "poi_short_description": "Picturesque uphill hiking trail known for its panoramic views at the summit.",
      "poi_long_description": "Picturesque uphill hiking trail known for its panoramic views at the summit.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-15c8-761f-8c83-00ad2c8d5807.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-15c8-761f-8c83-00ad2c8d5807",
        "storage_key": "property/6767906449167016/019d02d6-15c8-761f-8c83-00ad2c8d5807.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sandiego.gov/park-and-recreation/parks/osp/mtrails",
      "poi_directions_map_url": "https://maps.google.com/?cid=11457899975665487685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cowles-mountain-trailhead",
      "poi_latitude": "32.8046386",
      "poi_longitude": "-117.0377579",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 619-668-3281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7dApJEpW2YARRY9_QVKjAp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_c17602e2-50a8-4f5b-a57c-1d5ce9beca23",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Mission Trails Regional Park Visitor and Interpretive Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Father Junipero Serra Trail, San Diego, CA 92119, USA",
      "poi_short_description": "Relaxed spot with an interpretive center (often hosting concerts), dam and exhibits about the region’s flora and fauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d5-fa9e-72fb-952b-7a48af7756e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d5-fa9e-72fb-952b-7a48af7756e4",
        "storage_key": "property/6767906449167016/019d02d5-fa9e-72fb-952b-7a48af7756e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mtrp.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10824496055226796645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-trails-regional-park-visitor-and-interpretive-center",
      "poi_latitude": "32.8201492",
      "poi_longitude": "-117.0568411",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 619-668-3281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmVI-iYv924ARZQppxM9VOJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_4bdaff79-24d0-4084-ba24-7c828fe8e869",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Lake Murray Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7001 Murray Park Dr, San Diego, CA 92119, USA",
      "poi_short_description": "Laid-back area featuring a playground and picnic spots on the shore of Lake Murray.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-199c-705c-bd1e-c163ed094538.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-199c-705c-bd1e-c163ed094538",
        "storage_key": "property/6767906449167016/019d02d6-199c-705c-bd1e-c163ed094538.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sandiego.gov/park-and-recreation/centers/map",
      "poi_directions_map_url": "https://maps.google.com/?cid=9202200641845713687&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-murray-community-park",
      "poi_latitude": "32.791986",
      "poi_longitude": "-117.0441968",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 619-527-3443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-58e2-7129-b247-204997562d7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-58e2-7129-b247-204997562d7a",
        "storage_key": "property/6767906449167016/019d02d6-58e2-7129-b247-204997562d7a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnz927lpW2YARF9sVebrItH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_27a24548-213b-4dc9-b0ab-3ecc7541f802",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "San Carlos Recreation Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6445 Lake Badin Ave, San Diego, CA 92119, USA",
      "poi_short_description": "Park featuring playgrounds with swings and slides, plus courts for baseball, basketball and tennis.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-1a7d-7778-b235-95cb88f9e2b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-1a7d-7778-b235-95cb88f9e2b3",
        "storage_key": "property/6767906449167016/019d02d6-1a7d-7778-b235-95cb88f9e2b3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sandiego.gov/park-and-recreation/centers/recctr/sancarlos",
      "poi_directions_map_url": "https://maps.google.com/?cid=16929082041779046031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-carlos-recreation-center",
      "poi_latitude": "32.7981786",
      "poi_longitude": "-117.0217702",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-527-3443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN2IN7q9X2YARj0avQWwu8Oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_66082ecb-e166-486c-b4cd-a45c73eb51ae",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Old Mission Dam",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Father Junipero Serra Trail, San Diego, CA 92119, USA",
      "poi_short_description": "Beautiful park and historical site with easy paths, picnic spots and wildlife.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-1c6e-7038-8b4f-e8a88fe3ff68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-1c6e-7038-8b4f-e8a88fe3ff68",
        "storage_key": "property/6767906449167016/019d02d6-1c6e-7038-8b4f-e8a88fe3ff68.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://mtrp.org/old-mission-dam/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13363065097463894340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-mission-dam",
      "poi_latitude": "32.8395246",
      "poi_longitude": "-117.0431602",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 619-668-3281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbRitrpv924ARRJHB1Ockc7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_10a18a92-2b3c-4895-9a43-8528c0afa926",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Kumeyaay Lake Campground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2 Father Junipero Serra Trail, San Diego, CA 92119, USA",
      "poi_short_description": "Relaxed weekend-only campsites with 46 sites along a lake, fire rings & BBQ grills in a calm space.",
      "poi_long_description": "Relaxed weekend-only campsites with 46 sites along a lake, fire rings & BBQ grills in a calm space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-1d0f-713e-8409-bf349a6e8e12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-1d0f-713e-8409-bf349a6e8e12",
        "storage_key": "property/6767906449167016/019d02d6-1d0f-713e-8409-bf349a6e8e12.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mtrp.org/campground/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7537851987530549399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kumeyaay-lake-campground",
      "poi_latitude": "32.8398293",
      "poi_longitude": "-117.0335643",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 619-668-2748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-58e3-767b-86af-52d575d98419.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-58e3-767b-86af-52d575d98419",
        "storage_key": "property/6767906449167016/019d02d6-58e3-767b-86af-52d575d98419.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR4yTVR9W2YARlwg7BnLUm2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "custom_4b50344a-d481-4806-9a53-79c4c926f864",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Parking Lot",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10164 Father Junipero Serra Trail, Santee, CA 92071, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-2166-77df-b0af-95b69a574dcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-2166-77df-b0af-95b69a574dcd",
        "storage_key": "property/6767906449167016/019d02d6-2166-77df-b0af-95b69a574dcd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11190439251071702215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parking-lot",
      "poi_latitude": "32.8397508",
      "poi_longitude": "-117.0414439",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5947-764d-85d2-8a4f48565d0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5947-764d-85d2-8a4f48565d0a",
        "storage_key": "property/6767906449167016/019d02d6-5947-764d-85d2-8a4f48565d0a.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJa2R3bKr924ARx5S3mDVtTJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_28dd45bf-906d-415a-a75c-8979f5f6629a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Santee Lakes Recreation Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9310 Fanita Pkwy, Santee, CA 92071, USA",
      "poi_short_description": "Staycation spot for locals with 7 man-made lakes for camping, boating, fishing & picnics.",
      "poi_long_description": "Staycation spot for locals with 7 man-made lakes for camping, boating, fishing & picnics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-2109-7584-ba17-b1ca761630d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-2109-7584-ba17-b1ca761630d9",
        "storage_key": "property/6767906449167016/019d02d6-2109-7584-ba17-b1ca761630d9.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "http://www.santeelakes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3068124483151821601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santee-lakes-recreation-preserve",
      "poi_latitude": "32.8461647",
      "poi_longitude": "-117.0039378",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-596-3141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-58e2-7129-b247-204997562d7a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-58e2-7129-b247-204997562d7a",
        "storage_key": "property/6767906449167016/019d02d6-58e2-7129-b247-204997562d7a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJyRRl9z3924ARIXvxOPYqlCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3386fc95-9cf8-404e-9e2a-3e18716c67bd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "East Fortuna Staging Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Equestrian Cir, Santee, CA 92071, USA",
      "poi_short_description": "Hiking area with multiple trails, picnic tables, and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-23c8-765b-9577-5035d301bbea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-23c8-765b-9577-5035d301bbea",
        "storage_key": "property/6767906449167016/019d02d6-23c8-765b-9577-5035d301bbea.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://mtrp.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=260820312921181671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-fortuna-staging-area",
      "poi_latitude": "32.846625",
      "poi_longitude": "-117.029836",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-668-3281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgx1rrnX924AR543fVbGengM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_e2d38b13-47c4-4086-9029-0730117f237e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Grantville",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Diego, CA 92120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-2384-770c-b6c8-36f721aa7b2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-2384-770c-b6c8-36f721aa7b2d",
        "storage_key": "property/6767906449167016/019d02d6-2384-770c-b6c8-36f721aa7b2d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2739762465968131332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grantville",
      "poi_latitude": "32.7805967",
      "poi_longitude": "-117.0974443",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC67DuchV2YARBI36aHKXBSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_bb909e7c-b9f3-490a-bb20-18e9dadb7a8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Mission San Diego Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Diego, CA 92108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-283a-74dd-bac3-cb1a4cb49f5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-283a-74dd-bac3-cb1a4cb49f5c",
        "storage_key": "property/6767906449167016/019d02d6-283a-74dd-bac3-cb1a4cb49f5c.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.sdmts.com/schedules-real-time?fragment=green_line#section-main",
      "poi_directions_map_url": "https://maps.google.com/?cid=11348530469881848019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-san-diego-station",
      "poi_latitude": "32.780797",
      "poi_longitude": "-117.1109847",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsStuT7pV2YAR0yAB1FUUfp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_41142b4e-f19e-4a81-b780-da91c3261ca2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "UCSD Health East Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Diego, CA 92120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-29d3-723e-90e3-060e9e852ba4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-29d3-723e-90e3-060e9e852ba4",
        "storage_key": "property/6767906449167016/019d02d6-29d3-723e-90e3-060e9e852ba4.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.sdmts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=696069023432069384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ucsd-health-east-station",
      "poi_latitude": "32.7773165",
      "poi_longitude": "-117.0568333",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-233-3004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZb6TNotW2YARCFHSwBbvqAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_148dace9-b887-4da0-a50a-f5c960fc6e49",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "SDSU Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Diego, CA 92115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-2ab6-757a-ad28-6da6874f0aca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-2ab6-757a-ad28-6da6874f0aca",
        "storage_key": "property/6767906449167016/019d02d6-2ab6-757a-ad28-6da6874f0aca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9559719255319845454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sdsu-transit-center",
      "poi_latitude": "32.7730452",
      "poi_longitude": "-117.0715534",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3IQkYZW2YARThrNXQPyqoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_ab24301b-807a-4c9f-a4fa-f7014a74ef1a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Fashion Valley Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Diego, CA 92108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-2e93-745d-a419-34b60cf6296b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-2e93-745d-a419-34b60cf6296b",
        "storage_key": "property/6767906449167016/019d02d6-2e93-745d-a419-34b60cf6296b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101878976924513781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fashion-valley-transit-center",
      "poi_latitude": "32.76552059999999",
      "poi_longitude": "-117.1699826",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3XFejJV2YAR9XX29hvMEZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_73258bd1-bbd4-4d6c-8feb-bf3f53366941",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "San Diego Old Town Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4005 Taylor St, San Diego, CA 92110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-303f-70fc-bfad-f2fe4267d158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-303f-70fc-bfad-f2fe4267d158",
        "storage_key": "property/6767906449167016/019d02d6-303f-70fc-bfad-f2fe4267d158.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=OLT",
      "poi_directions_map_url": "https://maps.google.com/?cid=16641690540911863818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-diego-old-town-transportation-center",
      "poi_latitude": "32.75523039999999",
      "poi_longitude": "-117.1995263",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI57PVuaq3oARCqgHIWAp8-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_e316aa43-17f6-41c7-b1a3-63b99dcfd960",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "70th Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "7255 Alvarado Rd, La Mesa, CA 91942, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6813969552047340110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "70th-street-station",
      "poi_latitude": "32.7720848",
      "poi_longitude": "-117.0427489",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 619-557-4555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5947-764d-85d2-8a4f48565d0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5947-764d-85d2-8a4f48565d0a",
        "storage_key": "property/6767906449167016/019d02d6-5947-764d-85d2-8a4f48565d0a.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1x1sa-VW2YARTvobpDQVkF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_3c33fadf-4e33-4202-b0d8-4ef86f0dc436",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Grossmont Trolley Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "8601 Fletcher Pkwy, La Mesa, CA 91942, USA",
      "poi_short_description": "Shopping center with a mix of retailers, a movie theater, and a variety of dining options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-30df-75fc-8985-6886fd5a13cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-30df-75fc-8985-6886fd5a13cf",
        "storage_key": "property/6767906449167016/019d02d6-30df-75fc-8985-6886fd5a13cf.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14395836078374263562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grossmont-trolley-center",
      "poi_latitude": "32.7794452",
      "poi_longitude": "-117.0146896",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-4f54-718e-a6e3-6e0c02476521.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-4f54-718e-a6e3-6e0c02476521",
        "storage_key": "property/6767906449167016/019d02d6-4f54-718e-a6e3-6e0c02476521.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBWKa5RFX2YARChtAEKRIyMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e49d6457-3d73-4d45-b9a1-af5123c78a5a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "San Diego International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "Harbor Island Dr, San Diego, CA 92101, USA",
      "poi_short_description": "Airport serving Southern California, with rail service to Los Angeles & art exhibits.",
      "poi_long_description": "Airport serving Southern California, with rail service to Los Angeles & art exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-3501-72ef-8ea4-2d8540ba4b99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-3501-72ef-8ea4-2d8540ba4b99",
        "storage_key": "property/6767906449167016/019d02d6-3501-72ef-8ea4-2d8540ba4b99.webp",
        "width": 1280,
        "height": 211
      },
      "poi_business_url": "https://www.san.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1354982930337147238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-diego-international-airport",
      "poi_latitude": "32.7328907",
      "poi_longitude": "-117.1897122",
      "poi_miles_from_property": "12.9",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-59bd-760c-9c20-4c213572d117.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-59bd-760c-9c20-4c213572d117",
        "storage_key": "property/6767906449167016/019d02d6-59bd-760c-9c20-4c213572d117.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJp-YhDEir3oARZql2z8vdzRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_6cac11c8-4e77-4242-979a-d023561bbc8e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "University of California San Diego",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9500 Gilman Dr, La Jolla, CA 92093, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-3717-75da-bdea-4a868db006fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-3717-75da-bdea-4a868db006fb",
        "storage_key": "property/6767906449167016/019d02d6-3717-75da-bdea-4a868db006fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ucsd.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17273181422442593959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-california-san-diego",
      "poi_latitude": "32.881168",
      "poi_longitude": "-117.2343605",
      "poi_miles_from_property": "17.8",
      "poi_walking_minutes": "6 hours 43 mins",
      "poi_biking_minutes": "1 hour 59 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 858-534-2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5407-7043-a6df-567cbf07ab55",
        "storage_key": "property/6767906449167016/019d02d6-5407-7043-a6df-567cbf07ab55.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT69MQcQG3IARpz6Rifyqtu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7d6850fd-66be-48e9-a5ea-52b83a95347b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Qualcomm Building N",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5775 Morehouse Dr, San Diego, CA 92121, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-377b-75ff-a19a-6317691568c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-377b-75ff-a19a-6317691568c8",
        "storage_key": "property/6767906449167016/019d02d6-377b-75ff-a19a-6317691568c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2645194019845449883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qualcomm-building-n",
      "poi_latitude": "32.8963942",
      "poi_longitude": "-117.1961445",
      "poi_miles_from_property": "18",
      "poi_walking_minutes": "6 hours 38 mins",
      "poi_biking_minutes": "1 hour 52 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 858-587-1121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-49f1-7486-b995-8139e32c8630",
        "storage_key": "property/6767906449167016/019d02d6-49f1-7486-b995-8139e32c8630.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY6CPTBUH3IARmyjgOvKdtSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3b16cc07-517d-4980-91cb-bfa529145b15",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Scripps Mercy Hospital San Diego",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4077 Fifth Ave, San Diego, CA 92103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-3ad5-72e9-8b4d-3cb5780354be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-3ad5-72e9-8b4d-3cb5780354be",
        "storage_key": "property/6767906449167016/019d02d6-3ad5-72e9-8b4d-3cb5780354be.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.scripps.org/locations/hospitals/scripps-mercy-hospital-san-diego",
      "poi_directions_map_url": "https://maps.google.com/?cid=4371448057945766550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scripps-mercy-hospital-san-diego",
      "poi_latitude": "32.7514914",
      "poi_longitude": "-117.1604207",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 858-832-2478",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5452-7036-86f5-2e07e15fd2dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5452-7036-86f5-2e07e15fd2dc",
        "storage_key": "property/6767906449167016/019d02d6-5452-7036-86f5-2e07e15fd2dc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJG1uXAtpU2YARlrrtB9mAqjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_36ad11f6-e629-47ae-9ec6-2f11181a9f1f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Scripps Memorial Hospital La Jolla",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9888 Genesee Ave, La Jolla, CA 92037, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-3db0-727a-9a90-3810c87d568a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-3db0-727a-9a90-3810c87d568a",
        "storage_key": "property/6767906449167016/019d02d6-3db0-727a-9a90-3810c87d568a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.scripps.org/locations/hospitals/scripps-memorial-hospital-la-jolla?tab=overview",
      "poi_directions_map_url": "https://maps.google.com/?cid=7072719222878014132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scripps-memorial-hospital-la-jolla",
      "poi_latitude": "32.8849627",
      "poi_longitude": "-117.2250478",
      "poi_miles_from_property": "17.5",
      "poi_walking_minutes": "6 hours 35 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 858-834-1798",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5452-7036-86f5-2e07e15fd2dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5452-7036-86f5-2e07e15fd2dc",
        "storage_key": "property/6767906449167016/019d02d6-5452-7036-86f5-2e07e15fd2dc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJK1n7it4G3IARtIq4C6lYJ2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_08910cc9-562e-4b6b-baee-e7adca3806c1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Rady Children’s Hospital - San Diego",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3020 Children's Way, San Diego, CA 92123, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-3e5e-7111-bb62-09d2f65e4c59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-3e5e-7111-bb62-09d2f65e4c59",
        "storage_key": "property/6767906449167016/019d02d6-3e5e-7111-bb62-09d2f65e4c59.webp",
        "width": 752,
        "height": 395
      },
      "poi_business_url": "https://www.rchsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9989700038247520902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rady-childrens-hospital---san-diego",
      "poi_latitude": "32.7979816",
      "poi_longitude": "-117.1512449",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 858-576-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5452-7036-86f5-2e07e15fd2dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5452-7036-86f5-2e07e15fd2dc",
        "storage_key": "property/6767906449167016/019d02d6-5452-7036-86f5-2e07e15fd2dc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJSZqBu9dU2YARhhpz0EGLooo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e17002fb-be96-4efd-bdc9-7e47c28d6484",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "San Diego County Administration Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Pacific Hwy, San Diego, CA 92101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-407f-729c-bc03-4d8927f45fd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-407f-729c-bc03-4d8927f45fd5",
        "storage_key": "property/6767906449167016/019d02d6-407f-729c-bc03-4d8927f45fd5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sandiegocounty.gov/cob/cacs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11972494210477669466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-diego-county-administration-center",
      "poi_latitude": "32.7216642",
      "poi_longitude": "-117.1721016",
      "poi_miles_from_property": "12.8",
      "poi_walking_minutes": "4 hours 44 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 858-694-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5dc9-72ad-a811-2ece2c7fc9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5dc9-72ad-a811-2ece2c7fc9ff",
        "storage_key": "property/6767906449167016/019d02d6-5dc9-72ad-a811-2ece2c7fc9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJud-xQq1U2YARWjzxKg3YJqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_f4174e95-741c-4250-b3f6-ef08571fd70b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "San Diego City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "202 C St, San Diego, CA 92101, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-427f-76bc-ba1a-efc4f9a6948c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-427f-76bc-ba1a-efc4f9a6948c",
        "storage_key": "property/6767906449167016/019d02d6-427f-76bc-ba1a-efc4f9a6948c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sandiego.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8144209643291727739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-diego-city-hall",
      "poi_latitude": "32.7172775",
      "poi_longitude": "-117.1631761",
      "poi_miles_from_property": "12.5",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 619-236-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5dc9-72ad-a811-2ece2c7fc9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5dc9-72ad-a811-2ece2c7fc9ff",
        "storage_key": "property/6767906449167016/019d02d6-5dc9-72ad-a811-2ece2c7fc9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJRZnn_BU2YARe9e2TIULBnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_04073ba1-5587-462f-aee4-7dda9a83a73a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "custom",
      "poi_name": "Naval Base San Diego",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Naval Base, 3380 Sturtevant St, San Diego, CA 92136, USA",
      "poi_short_description": "Pacific Fleet base for destroyers, assault ships & support vessels, plus naval barracks & a theater.",
      "poi_long_description": "Pacific Fleet base for destroyers, assault ships & support vessels, plus naval barracks & a theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-43de-72c9-813a-3945fe810a72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d6-43de-72c9-813a-3945fe810a72",
        "storage_key": "property/6767906449167016/019d02d6-43de-72c9-813a-3945fe810a72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cnic.navy.mil/regions/cnrsw/installations/navbase_san_diego.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=15195485551845283968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "naval-base-san-diego",
      "poi_latitude": "32.6858247",
      "poi_longitude": "-117.1254215",
      "poi_miles_from_property": "12.7",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 619-556-1011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d6-5dc9-72ad-a811-2ece2c7fc9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d6-5dc9-72ad-a811-2ece2c7fc9ff",
        "storage_key": "property/6767906449167016/019d02d6-5dc9-72ad-a811-2ece2c7fc9ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ402zjVZS2YARgJhRq5k14dI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "custom_da077aa4-229b-4bab-9361-e51ff37ecef8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_dfcdfd05-055d-4cb6-99a2-dc84f0c6753d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_0278ff85-c8db-4538-9745-4e6ee7fdd4b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_fe7046aa-c915-4373-b35e-284d05b5475d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_ce449074-a296-4f7b-9508-9a68b75e7557",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_c3ea1c96-571b-45c2-a974-1e2c6ec0693e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "ec_428ebce6b7aa61d3dd66acbe",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8683-a695-71bd-b153-7dd51a99ee9f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f8683-a695-71bd-b153-7dd51a99ee9f",
        "storage_key": "property/6767906449167016/019f8683-a695-71bd-b153-7dd51a99ee9f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cowles Landing Studio",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=HHKB6T23rDM"
    },
    {
      "id": "ec_367415ab35382ef0df20bac0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019f8683-a696-7409-aa65-2d6e000b921e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f8683-a696-7409-aa65-2d6e000b921e",
        "storage_key": "property/6767906449167016/019f8683-a696-7409-aa65-2d6e000b921e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cowles Landing 1 Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=KjCdZHt7wCB"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019c2e9e-4028-762a-98a8-bbd5dc2e1772",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-cowles-landing",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016"
    },
    {
      "lead_collector_id": "01a01bc1-2d69-76a6-8c9c-a2cdca017e79",
      "lead_source": "LANDING_PAGE",
      "name": "Cowles Landing Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "senior-apartments-with-pool-san-carlos",
      "search_query": "senior apartments with pool in San Carlos",
      "category": "Amenity",
      "h1_title": "Senior Apartments with Pool in San Carlos",
      "h2_subtitle": "Discover senior apartments with a pool in San Carlos. Enjoy serene living at Cowles Landing, your perfect retreat.",
      "page_copy": "Experience the joy of senior living at Cowles Landing, located in the heart of San Carlos. Our community offers senior apartments with a pool, providing residents a refreshing way to unwind. The enchanting evening lights and tranquil spa add to the peaceful ambiance, creating an ideal environment for those 55 and better.\n\nAt Cowles Landing, each studio is designed with comfort in mind. Residents can enjoy modern amenities like air conditioning and reserved parking. Water is included, and our community maintains a non-smoking policy to ensure a clean atmosphere. Whether you're looking to relax by the pool or stroll through sunny San Diego, Cowles Landing is the perfect choice for senior living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Senior Apartments with Pool in San Carlos",
      "seo_description": "Explore Cowles Landing's senior apartments with a pool in San Carlos. Enjoy tranquil living with modern amenities!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-san-diego-county",
      "search_query": "air conditioned apartments San Diego County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in San Diego County",
      "h2_subtitle": "Explore air conditioned apartments in San Diego County. Cowles Landing offers cool comfort and modern amenities for residents 55 and better.",
      "page_copy": "Stay comfortable year-round in one of our air conditioned apartments at Cowles Landing, ideally located in San Diego County. Designed for residents 55 and better, our community ensures a pleasant living environment with essential amenities and serene surroundings. Relax in our studios, equipped with necessary comforts including a refrigerator and water service included.\n\nCowles Landing is more than just air conditioned living. Enjoy our community amenities like the pool, spa, and charming evening lights. Situated in vibrant San Carlos, residents can enjoy the tranquility of a suburban setting with the convenience of nearby city attractions. With reserved parking and a non-smoking policy, Cowles Landing cultivates a hassle-free lifestyle in sunny San Diego.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in San Diego County",
      "seo_description": "Find air conditioned apartments at Cowles Landing in San Diego County. Enjoy comfort and modern amenities in a serene environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "apartments-with-reserved-parking-92119",
      "search_query": "apartments with reserved parking in 92119",
      "category": "Amenity",
      "h1_title": "Apartments with Reserved Parking in 92119",
      "h2_subtitle": "Discover apartments with reserved parking in 92119. Cowles Landing in San Carlos offers convenience and comfort for residents.",
      "page_copy": "Located in the 92119 zip code, Cowles Landing offers apartments with reserved parking, making life easier for residents seeking convenience. Situated in the friendly neighborhood of San Carlos, this community caters to those 55 and better, providing a relaxed atmosphere. Enjoy modern amenities like air conditioning and non-smoking policies that enhance your living experience.\n\nAt Cowles Landing, not only do you benefit from reserved parking, but you can also enjoy a suite of gratifying amenities. Whether unwinding in our pool and spa or strolling under the beautiful evening lights, you'll find comfort here. Experience hassle-free living in a community designed with seniors in mind, ensuring a delightful sanctuary in sunny San Diego.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Reserved Parking in 92119",
      "seo_description": "Cowles Landing offers apartments with reserved parking in 92119. Enjoy convenience and comfort in San Carlos, perfect for seniors.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-san-carlos-ca",
      "search_query": "apartments with dishwasher San Carlos CA",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in San Carlos, CA",
      "h2_subtitle": "Explore apartments with a dishwasher in San Carlos, CA. Discover convenient living at Cowles Landing for those 55 and better.",
      "page_copy": "While Cowles Landing does not currently feature a dishwasher in its apartments, our community in San Carlos, CA, offers a range of other valuable amenities designed for residents 55 and better. Each studio is equipped with air conditioning and includes water as part of the lease, ensuring comfort and convenience. Our non-smoking property provides a healthy and serene environment, ideal for relaxed living.\n\nResidents of Cowles Landing can enjoy additional amenities such as reserved parking and access to a picturesque pool and spa, complete with enchanting evening lights. Located in the vibrant San Carlos neighborhood, our community offers easy access to all that sunny San Diego has to offer, making it an appealing choice for those seeking a peaceful yet well-connected living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in San Carlos, CA",
      "seo_description": "Discover convenient living at Cowles Landing in San Carlos, CA. Although no dishwasher, enjoy a host of other amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "55plus-apartments-near-community-spa-san-diego",
      "search_query": "55+ apartments near community spa San Diego",
      "category": "Amenity",
      "h1_title": "55+ Apartments Near Community Spa in San Diego",
      "h2_subtitle": "Explore 55+ apartments near a community spa in San Diego. Cowles Landing offers serene living with modern amenities.",
      "page_copy": "Cowles Landing presents an ideal living option for those seeking 55+ apartments near a community spa in San Diego. Nestled in the charming area of San Carlos, our community provides a tranquil retreat with a variety of amenities. Residents can revel in leisure activities, including unwinding by our sparkling pool and enjoying the soothing community spa.\n\nOur commitment to comfortable senior living is reflected in thoughtfully designed studio apartments equipped with air conditioning. With additional amenities like reserved parking, water included, and a non-smoking policy, Cowles Landing ensures a pleasant and hassle-free lifestyle. Embrace the balance of serenity and city living in beautiful San Diego County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "55+ Apartments Near Community Spa in San Diego",
      "seo_description": "Find 55+ apartments near a community spa at Cowles Landing, San Diego. Enjoy serene living with modern amenities in San Carlos.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "studio-apartments-san-carlos-ca",
      "search_query": "studio apartments san carlos ca",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in San Carlos, CA",
      "h2_subtitle": "Discover charming studio apartments in San Carlos, CA. Cowles Landing offers comfort and convenience for residents 55 and better.",
      "page_copy": "For those seeking studio apartments in San Carlos, CA, Cowles Landing provides an inviting option. Our studios are tailored specifically for residents aged 55 and better, offering a serene environment in sunny San Diego County. Each apartment is designed with comfort in mind, featuring modern amenities such as air conditioning and a non-smoking policy.\n\nLocated in the picturesque San Carlos neighborhood, Cowles Landing enhances community living with amenities like a sparkling pool, soothing spa, and enchanting evening lights. Reserved parking and included water add to the convenience, making Cowles Landing a standout choice for those looking to enjoy a relaxed yet well-connected lifestyle in San Carlos, CA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in San Carlos, CA",
      "seo_description": "Explore studio apartments at Cowles Landing, San Carlos, CA. Perfect for residents 55 and better, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-near-92119",
      "search_query": "one bedroom apartments near 92119",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near 92119",
      "h2_subtitle": "Explore one bedroom apartments near the 92119 area. Cowles Landing offers serene living in the heart of San Carlos.",
      "page_copy": "Although Cowles Landing specializes in studio living, those looking for one bedroom apartments near the 92119 zip code will discover a welcoming community designed for residents 55 and better. Situated in the charming San Carlos neighborhood, Cowles Landing provides a tranquil setting with modern amenities.\n\nResidents enjoy access to delightful features such as a sparkling community pool and spa, all set against the backdrop of enchanting evening lights. With air conditioning, reserved parking, and water included, Cowles Landing ensures a comfortable and convenient living experience, perfect for those seeking proximity to all that San Diego has to offer in the 92119 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near 92119",
      "seo_description": "Discover serene living at Cowles Landing near 92119. Although primarily studios, explore nearby one bedroom options in San Carlos.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-san-diego-county",
      "search_query": "two bedroom apartments san diego county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in San Diego County",
      "h2_subtitle": "While Cowles Landing focuses on studios, there are two bedroom options in San Diego County for those seeking more space.",
      "page_copy": "At Cowles Landing in the heart of San Diego County, our focus is on providing comfortable studio living for residents 55 and better. While we specialize in studio apartments, those seeking two bedroom options will find a variety of choices throughout the region.\n\nOur San Carlos community offers a serene living environment with amenities like a sparkling pool, a relaxing spa, and charming evening lights. With air conditioning, reserved parking, and water included, we offer a lifestyle of comfort and convenience. Discover the tranquil living atmosphere of Cowles Landing, strategically located to provide easy access to two bedroom apartment options within San Diego County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in San Diego County",
      "seo_description": "Explore Cowles Landing studios and two bedroom options in San Diego County, offering tranquil senior living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "apartments-near-gage-elementary-school",
      "search_query": "apartments near gage elementary school san carlos",
      "category": "School",
      "h1_title": "Apartments Near Gage Elementary School",
      "h2_subtitle": "Find ideal living at Cowles Landing, close to Gage Elementary School in San Carlos. Experience comfort in a thriving community.",
      "page_copy": "Cowles Landing offers a perfect blend of comfort and convenience for those seeking apartments near Gage Elementary School in San Carlos. Our community caters to residents 55 and older, providing modern studio apartments close to the educational facilities and amenities of the neighborhood.\n\nNestled in sunny San Diego, Cowles Landing features amenities such as a community pool, spa, and beautifully lit evenings. With air conditioning and reserved parking, our residents enjoy both comfort and peace of mind. Located near Gage Elementary, our community is perfect for those who appreciate a vibrant neighborhood atmosphere in San Carlos, CA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Gage Elementary School",
      "seo_description": "Discover Cowles Landing apartments near Gage Elementary in San Carlos. Enjoy senior living with modern amenities and serene surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "benchley-weinberger-elementary-apartments",
      "search_query": "benchley-weinberger elementary school apartments san diego",
      "category": "School",
      "h1_title": "Apartments Near Benchley-Weinberger School",
      "h2_subtitle": "Discover studio apartments close to Benchley-Weinberger Elementary in San Diego. Cowles Landing offers comfort and convenience.",
      "page_copy": "Situated in the vibrant community of San Carlos, Cowles Landing offers modern studio apartments ideal for those looking to stay near Benchley-Weinberger Elementary School. Our community, designed for residents 55 and better, features amenities like a refreshing pool, relaxing spa, and charming evening lights.\n\nWhile our focus is on comfortable studio living, Cowles Landing provides a tranquil environment that's also convenient for accessing local schools, including Benchley-Weinberger Elementary. Located in San Diego, our apartments come with air conditioning, reserved parking, and include water. Cowles Landing is your serene getaway in the bustling city.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Benchley-Weinberger School",
      "seo_description": "Explore Cowles Landing studios near Benchley-Weinberger Elementary in San Diego for serene senior living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "pershing-middle-school-nearby-apartments-92119",
      "search_query": "pershing middle school nearby apartments 92119",
      "category": "School",
      "h1_title": "Nearby Apartments to Pershing Middle School",
      "h2_subtitle": "Cowles Landing offers studio living close to Pershing Middle School in the 92119 area, perfect for convenient access and comfortable housing.",
      "page_copy": "Cowles Landing is a prime choice for those seeking studio apartments near Pershing Middle School in the 92119 area. Our community offers a serene lifestyle tailored for residents aged 55 and better, with modern amenities that make daily living a breeze.\n\nLocated in the heart of San Carlos, Cowles Landing provides key features like air conditioning, reserved parking, and utility inclusions such as water, ensuring a hassle-free living experience. Our proximity to Pershing Middle School makes it convenient for accessing local educational facilities while enjoying the serenity and comfort of our beautifully illuminated community with a pool and spa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Pershing Middle School",
      "seo_description": "Find Cowles Landing studios near Pershing Middle School in 92119. Enjoy senior living with amenities and easy school access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "patrick-henry-high-school-close-apartments",
      "search_query": "patrick henry high school close apartments san diego county",
      "category": "School",
      "h1_title": "Close Apartments to Patrick Henry High School",
      "h2_subtitle": "Discover comfortable studio living at Cowles Landing near Patrick Henry High School in San Diego County. Ideal for residents 55 and older.",
      "page_copy": "Cowles Landing presents ideal studio apartments conveniently located near Patrick Henry High School in San Diego County. Designed for residents aged 55 and better, our community provides a peaceful retreat with modern amenities that enhance your living experience.\n\nLocated in the welcoming neighborhood of San Carlos, Cowles Landing features amenities like evening lights, a community pool, and a soothing spa. Our location offers easy access to Patrick Henry High School, combining educational proximity with comfort. With conveniences like reserved parking and air conditioning, Cowles Landing ensures a delightful, easy lifestyle in the vibrant heart of San Diego County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close Apartments to Patrick Henry High School",
      "seo_description": "Explore Cowles Landing studios near Patrick Henry High School in San Diego County, featuring modern amenities for senior living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "myron-b-green-elementary-apartments-ca",
      "search_query": "myron b. green elementary school area apartments ca",
      "category": "School",
      "h1_title": "Apartments Near Myron B. Green Elementary",
      "h2_subtitle": "Explore Cowles Landing, offering convenient studio apartments near Myron B. Green Elementary School in beautiful San Diego, CA.",
      "page_copy": "Discover the convenience of living near Myron B. Green Elementary School at Cowles Landing in San Diego, CA. Our studio apartments cater to residents 55 and better, providing modern amenities that ensure comfort and ease.\n\nCowles Landing is located in the charming San Carlos neighborhood, making it an ideal choice for those seeking proximity to educational institutions like Myron B. Green Elementary. Enjoy amenities such as air conditioning, a swimming pool, and evening lights in a non-smoking community. Experience serenity and convenience at Cowles Landing, your perfect spot for comfortable California living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Myron B. Green Elementary",
      "seo_description": "Find Cowles Landing studios near Myron B. Green Elementary in San Diego, CA, offering senior living with modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "ralph-dailard-elementary-local-apartments",
      "search_query": "ralph dailard elementary school local apartments san carlos",
      "category": "School",
      "h1_title": "Local Apartments Near Ralph Dailard School",
      "h2_subtitle": "Cowles Landing offers studio apartments perfectly situated near Ralph Dailard Elementary School in the charming San Carlos neighborhood.",
      "page_copy": "Located in the vibrant San Carlos area, Cowles Landing provides convenient studio apartments near Ralph Dailard Elementary School. Tailored for residents aged 55 and better, our community ensures a serene living environment with a range of amenities.\n\nAt Cowles Landing, enjoy comforts like air conditioning, evening lights, and a refreshing pool. Our prime location not only offers proximity to Ralph Dailard Elementary but also a peaceful oasis with reserved parking and water included. Choose Cowles Landing for an ideal blend of educational proximity and modern, comfortable living within San Diego County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Local Apartments Near Ralph Dailard School",
      "seo_description": "Find Cowles Landing studios near Ralph Dailard Elementary in San Carlos, featuring senior-friendly amenities for a peaceful living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "millennial-tech-middle-school-nearby-living",
      "search_query": "millennial tech middle school nearby living san diego",
      "category": "School",
      "h1_title": "Living Close to Millennial Tech Middle School",
      "h2_subtitle": "Experience convenient living at Cowles Landing, offering studio apartments near Millennial Tech Middle School in San Diego.",
      "page_copy": "At Cowles Landing, you can enjoy a comfortable and convenient lifestyle near Millennial Tech Middle School in sunny San Diego. Our studio apartments cater to those aged 55 and better, offering a serene retreat with modern comforts.\n\nSituated in the lively San Carlos area, Cowles Landing boasts amenities such as air conditioning, a community pool, and charming evening lights, making it the perfect choice for nearby living. Additionally, this non-smoking property ensures hassle-free living with water and reserved parking included. Discover the ideal blend of educational proximity and relaxation at Cowles Landing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Millennial Tech Middle School",
      "seo_description": "Explore Cowles Landing studios near Millennial Tech Middle School in San Diego. Offering modern amenities for comfortable senior living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "springall-academy-apartments-san-diego-ca",
      "search_query": "springall academy apartments san diego ca",
      "category": "School",
      "h1_title": "Apartments Near Springall Academy, San Diego",
      "h2_subtitle": "Discover comfortable living at Cowles Landing, located close to Springall Academy in beautiful San Diego, CA.",
      "page_copy": "Cowles Landing offers a peaceful retreat just a short distance from Springall Academy, providing studio apartments that are both modern and convenient. This serene community in San Carlos caters to residents 55 and better, emphasizing a supportive and comfortable lifestyle.\n\nOur apartments come equipped with essential amenities like air conditioning and water inclusion, coupled with leisure features such as a community pool and evening lights. Nestled in the San Diego area, Cowles Landing also ensures non-smoking living spaces and reserved parking, perfect for those seeking proximity to educational institutions like Springall Academy within a tranquil neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Springall Academy, San Diego",
      "seo_description": "Find Cowles Landing studios near Springall Academy in San Diego, offering senior amenities and a serene living environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "apartments-near-san-diego-state-university",
      "search_query": "apartments near san diego state university",
      "category": "School",
      "h1_title": "Apartments Close to San Diego State University",
      "h2_subtitle": "Explore comfortable living at Cowles Landing, offering ideal apartments near San Diego State University for seniors.",
      "page_copy": "Situated in the charming San Carlos neighborhood, Cowles Landing provides studio apartments conveniently located near San Diego State University. Tailored for residents aged 55 and better, our community promises a tranquil living experience with a focus on comfort and convenience.\n\nCowles Landing offers modern amenities including air conditioning, a community pool, and delightful evening lights. Perfect for seniors seeking proximity to San Diego State University, our non-smoking property ensures water is included, alongside reserved parking. Discover the ideal balance of accessibility and relaxation just a short journey from the bustling university environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to San Diego State University",
      "seo_description": "Discover Cowles Landing studios near SDSU, San Diego, perfect for senior living with modern amenities and a serene atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "apartments-near-sharp-grossmont-hospital",
      "search_query": "apartments near Sharp Grossmont Hospital San Diego",
      "category": "Hospital",
      "h1_title": "Apartments Near Sharp Grossmont Hospital",
      "h2_subtitle": "Find serene senior living at Cowles Landing, offering convenient apartments close to Sharp Grossmont Hospital, San Diego.",
      "page_copy": "Cowles Landing offers an ideal living environment in San Carlos, perfect for those seeking proximity to Sharp Grossmont Hospital in San Diego. Our senior-centered community features studio apartments designed to provide both comfort and modern amenities.\n\nResidents at Cowles Landing enjoy the convenience of a non-smoking property, evening lights, and a community pool. With water and reserved parking included, our apartments are perfect for those looking to balance accessibility to healthcare resources and a peaceful home setting. Experience the benefit of living near Sharp Grossmont Hospital while savoring the comforts of Cowles Landing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sharp Grossmont Hospital",
      "seo_description": "Explore Cowles Landing studios near Sharp Grossmont Hospital, San Diego, offering senior living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "apartments-near-lake-murray-park-san-diego",
      "search_query": "apartments near lake murray park san diego",
      "category": "Park",
      "h1_title": "Apartments Near Lake Murray Park, San Diego",
      "h2_subtitle": "Discover serene living at Cowles Landing, offering apartments perfectly situated near Lake Murray Park in sunny San Diego.",
      "page_copy": "Nestled in the picturesque San Carlos area, Cowles Landing provides comfortable studio apartments just moments away from Lake Murray Park in San Diego. Our community caters to residents aged 55 and better, focusing on providing a peaceful and relaxing environment.\n\nEnjoy amenities tailored to senior living, including air conditioning, evening lights, and a refreshing community pool. With water and reserved parking included, Cowles Landing is ideal for those who enjoy the beauty of Lake Murray Park while valuing the comforts of home. Experience the unique blend of accessibility to outdoor recreation and a tranquil living space.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lake Murray Park, San Diego",
      "seo_description": "Live at Cowles Landing, close to Lake Murray Park, San Diego. Enjoy senior living with great amenities and scenic surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "apartments-close-to-santee-lakes-recreation-preserve",
      "search_query": "apartments close to santee lakes recreation preserve san diego county",
      "category": "Park",
      "h1_title": "Apartments Near Santee Lakes Recreation Preserve",
      "h2_subtitle": "Enjoy senior living at Cowles Landing, offering studio apartments close to Santee Lakes Recreation Preserve in San Diego County.",
      "page_copy": "Located in the sunny enclave of San Carlos, Cowles Landing provides an ideal living environment for residents 55 and older, featuring studio apartments a short drive from Santee Lakes Recreation Preserve. This prime location offers residents the opportunity to enjoy outdoor adventures while residing in a peaceful community environment.\n\nCowles Landing is equipped with modern conveniences like air conditioning, a community pool, and lovely evening lights. For those who appreciate easy access to nature while relishing the comforts of home, our non-smoking property includes water and reserved parking, making it a perfect choice for seniors near the Santee Lakes Recreation Preserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Santee Lakes Recreation Preserve",
      "seo_description": "Discover Cowles Landing studios near Santee Lakes, San Diego County, perfect for senior living with modern amenities and natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "apartments-near-grantville-san-diego",
      "search_query": "apartments near Grantville San Diego",
      "category": "Transit",
      "h1_title": "Apartments Near Grantville, San Diego",
      "h2_subtitle": "Explore comfortable living at Cowles Landing, featuring apartments conveniently located near Grantville in vibrant San Diego.",
      "page_copy": "Cowles Landing offers a welcoming retreat in San Carlos, with studio apartments just a quick drive from the bustling area of Grantville, San Diego. Our community caters to residents aged 55 and over, focusing on providing a serene and well-equipped living environment.\n\nResidents can enjoy a range of amenities such as air conditioning, a refreshing community pool, and delightful evening lights. Our non-smoking property also includes water and reserved parking for convenience. Experience the perfect blend of proximity to Grantville’s lively amenities and the tranquility of Cowles Landing, a haven for senior living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Grantville, San Diego",
      "seo_description": "Live at Cowles Landing, near Grantville, San Diego. Senior-friendly apartments with modern amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "living-close-to-mission-san-diego-station",
      "search_query": "living close to Mission San Diego Station 92119",
      "category": "Transit",
      "h1_title": "Living Close to Mission San Diego Station",
      "h2_subtitle": "Discover senior living at Cowles Landing, perfectly situated near Mission San Diego Station in San Diego's 92119 area.",
      "page_copy": "At Cowles Landing, experience unparalleled convenience and comfort in San Diego's 92119 area, living close to Mission San Diego Station. Our community is tailored for residents 55 and better, offering an ideal location that combines accessibility with tranquil surroundings.\n\nResidents enjoy modern amenities such as air conditioning, evening lights, and a community pool, providing both comfort and convenience. With water and reserved parking included, Cowles Landing is the perfect choice for seniors seeking a serene home environment close to the bustling hub of Mission San Diego Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Mission San Diego Station",
      "seo_description": "Find senior living at Cowles Landing, near Mission San Diego Station in 92119, offering convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "apartments-by-ucsd-health-east-station-ca",
      "search_query": "apartments by UCSD Health East Station CA",
      "category": "Transit",
      "h1_title": "Apartments by UCSD Health East Station",
      "h2_subtitle": "Experience senior living at Cowles Landing, located within easy reach of UCSD Health East Station in sunny San Diego, CA.",
      "page_copy": "Cowles Landing is a premier choice for seniors seeking apartments by UCSD Health East Station, offering a peaceful environment in San Diego's desirable San Carlos locale. Perfectly designed for residents 55 and older, our community merges modern living with convenient proximity to medical facilities.\n\nOur residents enjoy amenities like air conditioning, a sparkling community pool, and charming evening lights. This non-smoking property also provides water, reserved parking, and a serene atmosphere ideal for senior living. Relish in the ease of accessing UCSD Health East Station while residing in comfort and style at Cowles Landing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by UCSD Health East Station",
      "seo_description": "Senor living at Cowles Landing, near UCSD Health East Station, CA. Enjoy modern amenities and accessible location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167016",
      "source": "generator",
      "page_item_url": "housing-near-san-diego-international-airport",
      "search_query": "housing near San Diego International Airport San Carlos",
      "category": "Transit",
      "h1_title": "Housing Near San Diego International Airport",
      "h2_subtitle": "Discover senior housing at Cowles Landing, just a short drive from San Diego International Airport, nestled in the San Carlos area.",
      "page_copy": "Cowles Landing offers an ideal living option for those seeking housing near San Diego International Airport, with a prime location in San Carlos. Tailored for residents aged 55 and better, our community ensures that you enjoy both convenience and tranquility.\n\nAt Cowles Landing, you can take advantage of amenities such as air conditioning, evening lights, and a relaxing community pool, all in a non-smoking environment. Additionally, water and reserved parking are included, making life easy and comfortable. Combine easy airport access with a serene residential experience at Cowles Landing, where modern conveniences meet serene living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and surrounding buildings at a multifamily property.",
        "public_id": "019d02d4-a395-7320-95d0-2eaf99b4db51",
        "storage_key": "property/6767906449167016/019d02d4-a395-7320-95d0-2eaf99b4db51.webp",
        "width": 1800,
        "height": 1350
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near San Diego International Airport",
      "seo_description": "Explore senior housing at Cowles Landing near San Carlos, close to San Diego International Airport. Enjoy tranquility and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "lindseye@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6025"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11116497498"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NBZ5CGGV"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "1145CWLD"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'><script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('US6icNBgdSJ3UaVfc5')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "49961473679"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8ywk547gwlx"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "01525033"
    },
    {
      "ID": "custom_website_tracking_email",
      "type": "STRING",
      "value": "amcllc_cowleslanding_gaw_googleads@leads.anyonehome.com"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC_LLC/Cowles_Landing/scheduletourwidget/EJZf88XMr8xVryjnm2/"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "888-993-9018"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imp2NGlYSFI4TGZDdEdCU29YZzF1VEE9PSIsInZhbHVlIjoiQ1grdE5ndVB0L2hzRkF4eHplNUxNZz09IiwibWFjIjoiMmQ0YThjYWMwYTRiZTA1YjUyN2E3YWFkYzhhMTkyZTRmM2I3NWQ3ZGRiMTZjOGRmNjJlOGE3NjVmMjIyNmIwNiJ9"
    }
  ],
  "custom_csm": "lindseye@repli360.com",
  "custom_qb_id": "6025",
  "custom_repli_id": "11116497498",
  "custom_google_gtm_id": "GTM-NBZ5CGGV",
  "custom_rollout_phase": "Pathfinder 3",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "essential",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "1145CWLD",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'><script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('US6icNBgdSJ3UaVfc5')</script>",
  "custom_hubspot_company_id": "49961473679",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8ywk547gwlx",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "01525033",
  "custom_website_tracking_email": "amcllc_cowleslanding_gaw_googleads@leads.anyonehome.com",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC_LLC/Cowles_Landing/scheduletourwidget/EJZf88XMr8xVryjnm2/",
  "custom_ppc_tracking_phone_number": "888-993-9018",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imp2NGlYSFI4TGZDdEdCU29YZzF1VEE9PSIsInZhbHVlIjoiQ1grdE5ndVB0L2hzRkF4eHplNUxNZz09IiwibWFjIjoiMmQ0YThjYWMwYTRiZTA1YjUyN2E3YWFkYzhhMTkyZTRmM2I3NWQ3ZGRiMTZjOGRmNjJlOGE3NjVmMjIyNmIwNiJ9",
  "custom_audioeye_site_id": "ca7feb02-f4eb-4a65-a1de-9eb9480148be",
  "custom_audioeye_site_hash": "e3d9340c261c63c392bc6cecd508ede8"
};

export const generatedAt = '2026-10-16T14:53:21.079Z';
